export default {
  'title': 'China with Hong Kong, Macau, and Taiwan',
  'version': '1.1.2',
  'type': 'FeatureCollection',
  'copyright': 'Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth',
  'copyrightShort': 'Natural Earth',
  'copyrightUrl': 'http://www.naturalearthdata.com',
  'crs': { 'type': 'name', 'properties': { 'name': 'urn:ogc:def:crs:EPSG:3415' } },
  'hc-transform': {
    'default': {
      'crs': '+proj=lcc +lat_1=18 +lat_2=24 +lat_0=21 +lon_0=114 +x_0=500000 +y_0=500000 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs',
      'scale': 0.000129831107685,
      'jsonres': 15.5,
      'jsonmarginX': -999,
      'jsonmarginY': 9851.0,
      'xoffset': -3139937.49309,
      'yoffset': 4358972.7486
    }
  },
  'features': [{
    'type': 'Feature',
    'id': 'TW.PH',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.41,
      'hc-key': 'tw-ph',
      'hc-a2': 'PH',
      'labelrank': '9',
      'hasc': 'TW.TW.PH',
      'alt-name': null,
      'woe-id': '22695856',
      'subregion': null,
      'fips': null,
      'postal-code': 'PH',
      'name': 'Penghu',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '119.597',
      'woe-name': 'Penghu County',
      'latitude': '23.5724',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7477, 2683], [7484, 2676], [7473, 2673], [7469, 2681], [7477, 2683]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.SH',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.96,
      'hc-middle-y': 0.82,
      'hc-key': 'cn-sh',
      'hc-a2': 'SH',
      'labelrank': '7',
      'hasc': 'CN.SH',
      'alt-name': 'Sh脿ngh?i',
      'woe-id': '12578012',
      'subregion': null,
      'fips': 'CH23',
      'postal-code': 'SH',
      'name': '上海市',
      'country': 'China',
      'type-en': 'Municipality',
      'region': 'East China',
      'longitude': '121.409',
      'woe-name': 'Shanghai',
      'latitude': '31.0909',
      'woe-label': 'Shanghai, CN, China',
      'type': 'Zh铆xi谩sh矛'
    },
    'geometry': {
      'type': 'MultiPolygon',
      'coordinates': [[[[7863, 4465], [7851, 4460], [7744, 4504], [7716, 4532], [7733, 4546], [7774, 4532], [7812, 4507], [7875, 4484], [7863, 4465]]], [[[7751, 4467], [7828, 4423], [7860, 4383], [7881, 4343], [7868, 4329], [7815, 4322], [7747, 4286], [7712, 4317], [7688, 4315], [7684, 4355], [7672, 4355], [7662, 4383], [7701, 4388], [7722, 4458], [7751, 4467]]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.KM',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.51,
      'hc-middle-y': 0.50,
      'hc-key': 'tw-km',
      'hc-a2': 'KM',
      'labelrank': '9',
      'hasc': 'TW.FK.KM',
      'alt-name': 'Chinmen|Jinmen',
      'woe-id': '28760735',
      'subregion': null,
      'fips': null,
      'postal-code': 'KM',
      'name': 'Kinmen',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Fujian Province',
      'longitude': '118.368',
      'woe-name': 'Kinmen',
      'latitude': '24.454',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7234, 2879], [7234, 2858], [7201, 2854], [7200, 2871], [7234, 2879]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.ZJ',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.48,
      'hc-middle-y': 0.51,
      'hc-key': 'cn-zj',
      'hc-a2': 'ZJ',
      'labelrank': '2',
      'hasc': 'CN.ZJ',
      'alt-name': 'Zh猫ji?ng',
      'woe-id': '12577992',
      'subregion': null,
      'fips': 'CH02',
      'postal-code': 'ZJ',
      'name': '浙江省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'East China',
      'longitude': '119.97',
      'woe-name': 'Zhejiang',
      'latitude': '29.1084',
      'woe-label': 'Zhejiang, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'MultiPolygon',
      'coordinates': [[[[7972, 4135], [7973, 4110], [7943, 4102], [7970, 4114], [7972, 4135]]], [[[7927, 4194], [7907, 4203], [7934, 4217], [7929, 4161], [7959, 4147], [7954, 4125], [7932, 4137], [7901, 4136], [7890, 4152], [7875, 4132], [7872, 4153], [7904, 4182], [7922, 4165], [7927, 4194]]], [[[7672, 4355], [7684, 4355], [7688, 4315], [7712, 4317], [7747, 4286], [7690, 4250], [7684, 4222], [7655, 4192], [7637, 4214], [7585, 4211], [7628, 4205], [7646, 4178], [7677, 4165], [7726, 4202], [7771, 4204], [7797, 4182], [7833, 4134], [7894, 4112], [7924, 4112], [7892, 4094], [7843, 4037], [7809, 4022], [7792, 4024], [7806, 3996], [7817, 4014], [7884, 4055], [7897, 4012], [7886, 3999], [7894, 3925], [7864, 3936], [7864, 3994], [7855, 3954], [7837, 3949], [7823, 3973], [7788, 3930], [7831, 3933], [7846, 3889], [7809, 3896], [7844, 3869], [7832, 3846], [7803, 3837], [7837, 3797], [7831, 3783], [7847, 3760], [7810, 3756], [7795, 3745], [7791, 3718], [7772, 3727], [7775, 3703], [7749, 3688], [7742, 3709], [7766, 3741], [7752, 3765], [7741, 3728], [7713, 3675], [7661, 3678], [7687, 3667], [7683, 3639], [7643, 3578], [7660, 3562], [7653, 3536], [7635, 3540], [7631, 3495], [7611, 3495], [7595, 3533], [7555, 3537], [7539, 3523], [7480, 3515], [7462, 3558], [7434, 3594], [7418, 3560], [7379, 3536], [7309, 3545], [7301, 3600], [7286, 3642], [7272, 3655], [7279, 3716], [7267, 3734], [7220, 3719], [7210, 3724], [7215, 3734], [7203, 3816], [7162, 3873], [7129, 3894], [7116, 3914], [7126, 3944], [7141, 3950], [7149, 3975], [7188, 3986], [7223, 4026], [7255, 4050], [7258, 4072], [7287, 4108], [7278, 4148], [7282, 4185], [7354, 4183], [7382, 4198], [7367, 4232], [7351, 4238], [7378, 4270], [7390, 4260], [7414, 4308], [7422, 4373], [7443, 4383], [7481, 4379], [7483, 4364], [7521, 4333], [7566, 4334], [7583, 4324], [7593, 4296], [7634, 4326], [7630, 4345], [7672, 4355]]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.LK',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.21,
      'hc-key': 'tw-lk',
      'hc-a2': 'LK',
      'labelrank': '9',
      'hasc': 'TW.FK.LK',
      'alt-name': null,
      'woe-id': '28760734',
      'subregion': null,
      'fips': null,
      'postal-code': 'LK',
      'name': '连江',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Fujian Province',
      'longitude': '119.938',
      'woe-name': 'Lienchiang',
      'latitude': '26.1519',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7523, 3257], [7529, 3258], [7521, 3253], [7519, 3256], [7523, 3257]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.3664',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.50,
      'hc-key': 'cn-3664',
      'hc-a2': 'PI',
      'labelrank': '20',
      'hasc': 'CN',
      'alt-name': null,
      'woe-id': '12497556',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': '帕拉塞尔群岛',
      'country': 'China',
      'type-en': null,
      'region': null,
      'longitude': '111.201',
      'woe-name': 'Paracel Islands',
      'latitude': '15.7833',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[5722, 928], [5719, 927], [5720, 930], [5722, 930], [5722, 928]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.3681',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.30,
      'hc-middle-y': 0.41,
      'hc-key': 'cn-3681',
      'hc-a2': 'MA',
      'labelrank': '20',
      'hasc': 'MO',
      'alt-name': null,
      'woe-id': '20070017',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Macau',
      'country': 'Macau S.A.R',
      'type-en': null,
      'region': null,
      'longitude': '113.56',
      'woe-name': 'Macau',
      'latitude': '22.1349',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6234, 2344], [6240, 2337], [6232, 2331], [6229, 2344], [6234, 2344]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.FJ',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.56,
      'hc-middle-y': 0.36,
      'hc-key': 'cn-fj',
      'hc-a2': 'FJ',
      'labelrank': '2',
      'hasc': 'CN.FJ',
      'alt-name': 'F煤ji脿n',
      'woe-id': '12577997',
      'subregion': null,
      'fips': 'CH07',
      'postal-code': 'FJ',
      'name': '福建省',
      'country': 'China',
      'type-en': 'Province',
      'region': null,
      'longitude': '118.178',
      'woe-name': 'Fujian',
      'latitude': '26.408',
      'woe-label': 'Fujian, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'MultiPolygon',
      'coordinates': [[[[7431, 3219], [7450, 3230], [7477, 3217], [7455, 3179], [7456, 3148], [7429, 3148], [7456, 3099], [7409, 3116], [7407, 3092], [7387, 3101], [7360, 3087], [7375, 3066], [7397, 3068], [7411, 3048], [7400, 3036], [7362, 3037], [7337, 3055], [7314, 3042], [7334, 3035], [7313, 3013], [7342, 2982], [7286, 2955], [7275, 2980], [7266, 2955], [7296, 2935], [7274, 2894], [7229, 2906], [7181, 2888], [7174, 2862], [7154, 2879], [7142, 2863], [7100, 2865], [7124, 2849], [7152, 2853], [7169, 2822], [7137, 2799], [7123, 2769], [7102, 2763], [7095, 2778], [7073, 2741], [7063, 2703], [7060, 2737], [7043, 2733], [7033, 2703], [7049, 2703], [7008, 2665], [7022, 2689], [7001, 2713], [6991, 2672], [6978, 2674], [6949, 2701], [6924, 2776], [6933, 2800], [6914, 2846], [6887, 2881], [6890, 2907], [6842, 2894], [6809, 2944], [6756, 2945], [6710, 2960], [6700, 3022], [6727, 3057], [6736, 3121], [6763, 3153], [6758, 3173], [6795, 3193], [6814, 3237], [6809, 3267], [6853, 3314], [6829, 3358], [6837, 3398], [6861, 3425], [6912, 3433], [6935, 3454], [6957, 3491], [6946, 3507], [6948, 3556], [6982, 3603], [6981, 3622], [7025, 3648], [7045, 3625], [7073, 3614], [7088, 3642], [7135, 3653], [7148, 3667], [7195, 3682], [7191, 3708], [7210, 3724], [7220, 3719], [7267, 3734], [7279, 3716], [7272, 3655], [7286, 3642], [7301, 3600], [7309, 3545], [7379, 3536], [7418, 3560], [7434, 3594], [7462, 3558], [7480, 3515], [7539, 3523], [7555, 3537], [7595, 3533], [7611, 3495], [7600, 3471], [7577, 3477], [7587, 3433], [7555, 3431], [7535, 3415], [7556, 3401], [7548, 3367], [7524, 3359], [7510, 3338], [7506, 3358], [7529, 3368], [7546, 3398], [7516, 3399], [7503, 3367], [7490, 3374], [7490, 3409], [7472, 3356], [7497, 3322], [7486, 3312], [7464, 3331], [7471, 3291], [7499, 3316], [7510, 3291], [7469, 3283], [7454, 3256], [7465, 3237], [7443, 3241], [7431, 3219]], [[7431, 3219], [7424, 3215], [7424, 3215], [7424, 3215], [7424, 3215], [7388, 3217], [7406, 3204], [7424, 3215], [7424, 3215], [7424, 3215], [7424, 3215], [7428, 3214], [7431, 3219]]], [[[7486, 3141], [7516, 3122], [7493, 3088], [7480, 3094], [7497, 3114], [7486, 3141]]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.GD',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.46,
      'hc-middle-y': 0.32,
      'hc-key': 'cn-gd',
      'hc-a2': 'GD',
      'labelrank': '2',
      'hasc': 'CN.GD',
      'alt-name': 'Gu?ngd?ng',
      'woe-id': '12578019',
      'subregion': null,
      'fips': 'CH30',
      'postal-code': 'GD',
      'name': '广东省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'South Central China',
      'longitude': '113.72',
      'woe-name': 'Guangdong',
      'latitude': '23.7924',
      'woe-label': 'Guangdong, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'MultiPolygon',
      'coordinates': [[[[5610, 2081], [5566, 2095], [5546, 2088], [5551, 2111], [5601, 2111], [5610, 2081]]], [[[6373, 2432], [6359, 2433], [6343, 2426], [6318, 2428], [6303, 2409], [6273, 2477], [6254, 2477], [6246, 2509], [6250, 2538], [6230, 2530], [6240, 2552], [6219, 2542], [6238, 2493], [6192, 2506], [6251, 2454], [6234, 2393], [6255, 2404], [6222, 2346], [6207, 2349], [6172, 2398], [6153, 2436], [6153, 2415], [6202, 2348], [6174, 2328], [6159, 2301], [6136, 2355], [6124, 2340], [6124, 2300], [6100, 2277], [6082, 2301], [6044, 2275], [6037, 2259], [6002, 2271], [5986, 2250], [5961, 2244], [5946, 2269], [5913, 2267], [5888, 2294], [5890, 2270], [5910, 2260], [5888, 2234], [5906, 2224], [5873, 2213], [5883, 2248], [5847, 2258], [5864, 2239], [5833, 2207], [5793, 2208], [5719, 2196], [5639, 2170], [5609, 2118], [5578, 2133], [5580, 2178], [5568, 2162], [5573, 2130], [5533, 2113], [5522, 2061], [5567, 2060], [5551, 2018], [5588, 1997], [5599, 1977], [5570, 1938], [5513, 1928], [5492, 1940], [5468, 1929], [5458, 1964], [5481, 1952], [5490, 1966], [5473, 1986], [5453, 1987], [5442, 2057], [5419, 2081], [5428, 2135], [5444, 2145], [5443, 2176], [5476, 2177], [5481, 2206], [5452, 2202], [5441, 2225], [5477, 2249], [5488, 2289], [5574, 2295], [5566, 2359], [5593, 2350], [5630, 2356], [5636, 2375], [5658, 2378], [5640, 2423], [5655, 2444], [5711, 2456], [5720, 2478], [5744, 2480], [5780, 2515], [5793, 2551], [5784, 2566], [5790, 2631], [5807, 2671], [5834, 2681], [5846, 2721], [5870, 2719], [5896, 2756], [5890, 2808], [5912, 2818], [5927, 2841], [5919, 2879], [5904, 2890], [5918, 2920], [5948, 2932], [5944, 2967], [5957, 3012], [6013, 3014], [6054, 3003], [6083, 2964], [6120, 2969], [6116, 3017], [6126, 3032], [6100, 3031], [6104, 3048], [6167, 3089], [6241, 3049], [6291, 3056], [6311, 3076], [6328, 3073], [6331, 3036], [6349, 3045], [6382, 3041], [6413, 3062], [6441, 3067], [6469, 3041], [6474, 3005], [6410, 2972], [6387, 2922], [6360, 2903], [6413, 2865], [6428, 2877], [6477, 2893], [6502, 2885], [6539, 2911], [6558, 2907], [6615, 2929], [6674, 2877], [6692, 2881], [6684, 2940], [6710, 2960], [6756, 2945], [6809, 2944], [6842, 2894], [6890, 2907], [6887, 2881], [6914, 2846], [6933, 2800], [6924, 2776], [6949, 2701], [6978, 2674], [6959, 2659], [6956, 2682], [6933, 2657], [6923, 2682], [6915, 2636], [6896, 2613], [6844, 2626], [6858, 2605], [6891, 2608], [6871, 2571], [6863, 2588], [6848, 2559], [6854, 2539], [6840, 2521], [6800, 2526], [6758, 2494], [6764, 2510], [6703, 2476], [6673, 2507], [6641, 2474], [6651, 2458], [6610, 2464], [6620, 2479], [6581, 2484], [6595, 2496], [6546, 2486], [6508, 2433], [6482, 2439], [6488, 2490], [6442, 2471], [6438, 2435], [6454, 2422], [6433, 2409], [6408, 2444], [6373, 2432]]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.TW',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.55,
      'hc-middle-y': 0.55,
      'hc-key': 'tw-tw',
      'hc-a2': 'TW',
      'labelrank': '9',
      'hasc': 'TW.TP.TC',
      'alt-name': 'Taibei Shi',
      'woe-id': '20070568',
      'subregion': null,
      'fips': 'TW03',
      'postal-code': 'TW',
      'name': 'Taipei City',
      'country': 'Taiwan',
      'type-en': 'Special Municipality',
      'region': 'Special Municipalities',
      'longitude': '121.559',
      'woe-name': 'Taipei City',
      'latitude': '25.0904',
      'woe-label': null,
      'type': 'Zhixiashi'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7875, 3008], [7864, 3007], [7842, 3038], [7862, 3059], [7882, 3019], [7875, 3008]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.CS',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.43,
      'hc-key': 'tw-cs',
      'hc-a2': 'CS',
      'labelrank': '9',
      'hasc': 'TW.TW.CS',
      'alt-name': 'Jiayi Shi|Chiai City',
      'woe-id': '28751583',
      'subregion': null,
      'fips': null,
      'postal-code': 'CS',
      'name': 'Chiayi City',
      'country': 'Taiwan',
      'type-en': 'Provincial City',
      'region': 'Taiwan Province',
      'longitude': '120.441',
      'woe-name': 'Chiayi City',
      'latitude': '23.4822',
      'woe-label': null,
      'type': 'Shi'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7638, 2670], [7651, 2672], [7663, 2661], [7652, 2656], [7638, 2670]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6657',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.47,
      'hc-middle-y': 0.22,
      'hc-key': 'cn-6657',
      'hc-a2': 'SO',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703130',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Southern',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'Hong Kong Island',
      'longitude': '114.204',
      'woe-name': 'Southern',
      'latitude': '22.2402',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6378, 2363], [6369, 2350], [6349, 2368], [6352, 2368], [6360, 2365], [6362, 2365], [6365, 2366], [6374, 2365], [6378, 2363]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6663',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.43,
      'hc-middle-y': 0.46,
      'hc-key': 'cn-6663',
      'hc-a2': 'SK',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703139',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Sai Kung',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'The New Territories',
      'longitude': '114.249',
      'woe-name': 'Sai Kung',
      'latitude': '22.3463',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6402, 2407], [6390, 2374], [6376, 2372], [6376, 2379], [6374, 2382], [6372, 2387], [6375, 2392], [6378, 2396], [6392, 2401], [6402, 2407]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6665',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.51,
      'hc-middle-y': 0.38,
      'hc-key': 'cn-6665',
      'hc-a2': 'KT',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703132',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Kwai Tsing',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'The New Territories',
      'longitude': '114.14',
      'woe-name': 'Kwai Tsing',
      'latitude': '22.351',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'MultiPolygon',
      'coordinates': [[[[6354, 2378], [6353, 2378], [6355, 2378], [6354, 2378]]], [[[6356, 2382], [6349, 2386], [6349, 2387], [6355, 2389], [6357, 2389], [6358, 2387], [6359, 2384], [6357, 2383], [6356, 2382]]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6666',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.57,
      'hc-middle-y': 0.40,
      'hc-key': 'cn-6666',
      'hc-a2': 'TW',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703140',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Tsuen Wan',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'The New Territories',
      'longitude': '114.12',
      'woe-name': 'Tsuen Wan',
      'latitude': '22.3869',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'MultiPolygon',
      'coordinates': [[[[6357, 2389], [6355, 2389], [6349, 2387], [6342, 2389], [6330, 2386], [6330, 2391], [6333, 2393], [6341, 2396], [6354, 2399], [6358, 2401], [6361, 2401], [6362, 2396], [6357, 2389]]], [[[6325, 2378], [6340, 2385], [6332, 2378], [6325, 2378]]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6667',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.52,
      'hc-middle-y': 0.43,
      'hc-key': 'cn-6667',
      'hc-a2': 'TM',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703141',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Tuen Mun',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'The New Territories',
      'longitude': '113.991',
      'woe-name': 'Tuen Mun',
      'latitude': '22.3846',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6333, 2393], [6330, 2391], [6330, 2386], [6300, 2393], [6314, 2403], [6323, 2398], [6333, 2393]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6669',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.49,
      'hc-middle-y': 0.37,
      'hc-key': 'cn-6669',
      'hc-a2': 'NO',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703142',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'North',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'The New Territories',
      'longitude': '114.148',
      'woe-name': 'North',
      'latitude': '22.5063',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6344, 2424], [6343, 2426], [6359, 2433], [6373, 2432], [6386, 2432], [6395, 2422], [6370, 2419], [6355, 2412], [6347, 2413], [6344, 2424]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6670',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.43,
      'hc-middle-y': 0.35,
      'hc-key': 'cn-6670',
      'hc-a2': 'TP',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703144',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Tai Po',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'The New Territories',
      'longitude': '114.154',
      'woe-name': 'Tai Po',
      'latitude': '22.4447',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'MultiPolygon',
      'coordinates': [[[[6402, 2407], [6392, 2401], [6378, 2396], [6378, 2400], [6378, 2404], [6393, 2415], [6402, 2407]]], [[[6361, 2401], [6358, 2401], [6354, 2399], [6352, 2408], [6355, 2412], [6370, 2419], [6395, 2422], [6378, 2408], [6368, 2402], [6364, 2401], [6361, 2401]]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6671',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.48,
      'hc-key': 'cn-6671',
      'hc-a2': 'IS',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703127',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Islands',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'The New Territories',
      'longitude': '113.954',
      'woe-name': 'Islands',
      'latitude': '22.2597',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6325, 2378], [6332, 2378], [6329, 2358], [6294, 2352], [6304, 2373], [6325, 2378]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.KH',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.22,
      'hc-middle-y': 0.74,
      'hc-key': 'tw-kh',
      'hc-a2': 'KH',
      'labelrank': '9',
      'hasc': 'TW.KH.KC',
      'alt-name': 'Gaoxiong Shi',
      'woe-id': '20070571',
      'subregion': null,
      'fips': null,
      'postal-code': 'KH',
      'name': '高雄市',
      'country': 'Taiwan',
      'type-en': 'Special Municipality',
      'region': 'Special Municipalities',
      'longitude': '120.609',
      'woe-name': 'Kaohsiung City',
      'latitude': '23.0157',
      'woe-label': null,
      'type': 'Zhixiashi'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7652, 2442], [7635, 2449], [7615, 2480], [7598, 2540], [7635, 2533], [7651, 2543], [7695, 2610], [7705, 2625], [7756, 2667], [7764, 2665], [7768, 2659], [7763, 2643], [7776, 2629], [7750, 2615], [7740, 2529], [7715, 2535], [7661, 2521], [7652, 2442]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.HS',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.43,
      'hc-middle-y': 0.58,
      'hc-key': 'tw-hs',
      'hc-a2': 'HS',
      'labelrank': '9',
      'hasc': 'TW.TW.HS',
      'alt-name': 'Xinzhu Shi',
      'woe-id': '28751582',
      'subregion': null,
      'fips': null,
      'postal-code': 'HS',
      'name': 'Hsinchu City',
      'country': 'Taiwan',
      'type-en': 'Provincial City',
      'region': 'Taiwan Province',
      'longitude': '120.959',
      'woe-name': 'Hsinchu City',
      'latitude': '24.7757',
      'woe-label': null,
      'type': 'Shi'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7726, 2950], [7732, 2966], [7733, 2974], [7760, 2958], [7744, 2944], [7740, 2942], [7726, 2950]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.YN',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.42,
      'hc-middle-y': 0.59,
      'hc-key': 'cn-yn',
      'hc-a2': 'YN',
      'labelrank': '2',
      'hasc': 'CN.YN',
      'alt-name': 'Y煤nn谩n',
      'woe-id': '12578018',
      'subregion': 'Western',
      'fips': 'CH29',
      'postal-code': 'YN',
      'name': '云南省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'Southwest China',
      'longitude': '101.661',
      'woe-name': 'Yunnan',
      'latitude': '24.4603',
      'woe-label': 'Yunnan, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[3171, 3837], [3195, 3848], [3212, 3880], [3247, 3853], [3281, 3889], [3276, 3945], [3295, 3963], [3297, 4012], [3322, 4015], [3331, 3974], [3367, 4027], [3366, 4057], [3390, 4059], [3381, 3944], [3389, 3919], [3384, 3882], [3422, 3822], [3432, 3902], [3454, 3908], [3484, 3958], [3502, 3963], [3503, 3941], [3522, 3907], [3576, 3843], [3578, 3819], [3554, 3810], [3554, 3783], [3606, 3707], [3619, 3724], [3670, 3730], [3706, 3657], [3704, 3642], [3726, 3603], [3726, 3573], [3759, 3569], [3750, 3537], [3788, 3495], [3798, 3462], [3815, 3456], [3796, 3427], [3821, 3408], [3839, 3374], [3827, 3343], [3860, 3333], [3875, 3301], [3890, 3314], [3929, 3308], [3959, 3338], [4025, 3367], [4043, 3331], [4087, 3359], [4102, 3354], [4126, 3395], [4114, 3462], [4100, 3484], [4104, 3566], [4123, 3586], [4152, 3590], [4174, 3623], [4236, 3686], [4230, 3747], [4269, 3775], [4281, 3762], [4316, 3784], [4302, 3831], [4315, 3861], [4335, 3848], [4426, 3848], [4431, 3840], [4392, 3826], [4393, 3781], [4414, 3768], [4425, 3727], [4403, 3716], [4410, 3696], [4454, 3668], [4513, 3677], [4528, 3709], [4547, 3717], [4591, 3695], [4578, 3663], [4590, 3632], [4566, 3561], [4543, 3565], [4500, 3545], [4445, 3549], [4415, 3558], [4396, 3580], [4360, 3544], [4323, 3576], [4309, 3574], [4242, 3508], [4262, 3501], [4276, 3479], [4265, 3457], [4273, 3394], [4319, 3377], [4347, 3406], [4389, 3403], [4404, 3416], [4410, 3394], [4428, 3386], [4449, 3339], [4421, 3316], [4409, 3263], [4386, 3246], [4390, 3226], [4365, 3184], [4409, 3146], [4413, 3118], [4455, 3089], [4442, 3078], [4436, 3031], [4402, 2992], [4400, 2976], [4390, 2940], [4407, 2899], [4433, 2889], [4439, 2912], [4512, 2895], [4524, 2872], [4521, 2840], [4576, 2808], [4592, 2825], [4645, 2801], [4694, 2819], [4720, 2787], [4727, 2763], [4710, 2691], [4679, 2676], [4652, 2689], [4581, 2613], [4540, 2660], [4519, 2639], [4447, 2621], [4431, 2604], [4434, 2568], [4413, 2550], [4377, 2552], [4331, 2521], [4307, 2553], [4267, 2532], [4256, 2490], [4232, 2502], [4190, 2555], [4160, 2510], [4139, 2545], [4120, 2557], [4082, 2504], [4049, 2484], [4022, 2519], [3942, 2564], [3926, 2532], [3889, 2489], [3848, 2500], [3817, 2487], [3801, 2509], [3774, 2506], [3761, 2471], [3742, 2460], [3756, 2400], [3783, 2364], [3777, 2343], [3791, 2321], [3775, 2307], [3768, 2251], [3786, 2240], [3764, 2214], [3720, 2241], [3673, 2230], [3661, 2247], [3668, 2272], [3656, 2282], [3661, 2311], [3651, 2362], [3599, 2348], [3561, 2315], [3508, 2306], [3482, 2324], [3452, 2305], [3433, 2329], [3447, 2355], [3408, 2374], [3405, 2404], [3413, 2446], [3387, 2442], [3371, 2455], [3310, 2473], [3272, 2472], [3250, 2485], [3276, 2536], [3301, 2557], [3296, 2613], [3322, 2652], [3347, 2649], [3340, 2679], [3305, 2697], [3284, 2684], [3247, 2711], [3213, 2718], [3226, 2743], [3224, 2768], [3204, 2798], [3222, 2812], [3209, 2850], [3186, 2859], [3190, 2897], [3231, 2919], [3235, 2932], [3176, 2922], [3160, 2934], [3095, 2940], [3033, 2924], [2978, 2894], [2955, 2914], [2998, 2951], [3004, 2984], [2992, 3022], [2967, 3023], [2978, 3092], [3028, 3111], [3017, 3136], [3048, 3201], [3060, 3187], [3108, 3223], [3119, 3272], [3157, 3258], [3199, 3315], [3218, 3305], [3236, 3321], [3216, 3346], [3212, 3374], [3245, 3386], [3234, 3405], [3253, 3438], [3265, 3485], [3262, 3539], [3270, 3580], [3260, 3610], [3269, 3638], [3270, 3699], [3219, 3728], [3211, 3700], [3193, 3698], [3179, 3742], [3177, 3781], [3165, 3799], [3171, 3837]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.XZ',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.40,
      'hc-middle-y': 0.50,
      'hc-key': 'cn-xz',
      'hc-a2': 'XZ',
      'labelrank': '2',
      'hasc': 'CN.XZ',
      'alt-name': 'Tibet|X?z脿ng',
      'woe-id': '12578004',
      'subregion': 'Western',
      'fips': 'CH14',
      'postal-code': 'XZ',
      'name': '西藏自治区',
      'country': 'China',
      'type-en': 'Autonomous Region',
      'region': 'Southwest China',
      'longitude': '88.41370000000001',
      'woe-name': 'Xizang',
      'latitude': '31.4515',
      'woe-label': 'Tibet, CN, China',
      'type': 'Z矛zh矛qu'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[3390, 4059], [3366, 4057], [3367, 4027], [3331, 3974], [3322, 4015], [3297, 4012], [3295, 3963], [3276, 3945], [3281, 3889], [3247, 3853], [3212, 3880], [3195, 3848], [3171, 3837], [3125, 3892], [3102, 3897], [3091, 3928], [3067, 3936], [3044, 3904], [3042, 3884], [3016, 3869], [2978, 3907], [2948, 3902], [2901, 3965], [2873, 3967], [2857, 3932], [2850, 3976], [2884, 3994], [2882, 4017], [2845, 4086], [2813, 4074], [2811, 4093], [2840, 4104], [2847, 4127], [2821, 4125], [2811, 4152], [2732, 4154], [2724, 4127], [2700, 4137], [2681, 4113], [2641, 4118], [2634, 4100], [2573, 4134], [2538, 4138], [2513, 4175], [2491, 4158], [2464, 4156], [2437, 4134], [2450, 4116], [2405, 4093], [2298, 4055], [2263, 4060], [2201, 4028], [2185, 4001], [2132, 3968], [2090, 3954], [2098, 3938], [2080, 3913], [2011, 3893], [1965, 3901], [1945, 3888], [1878, 3905], [1887, 3940], [1843, 3963], [1821, 3989], [1778, 3968], [1701, 4005], [1660, 4008], [1687, 4040], [1620, 4079], [1547, 4075], [1522, 4054], [1482, 4049], [1429, 3997], [1405, 3987], [1379, 3950], [1363, 3948], [1338, 3912], [1343, 3888], [1322, 3888], [1302, 3912], [1300, 3944], [1333, 4006], [1331, 4041], [1294, 4072], [1244, 4052], [1191, 4052], [1189, 4033], [1133, 4053], [1110, 4034], [1072, 4047], [1039, 4045], [998, 4057], [978, 4086], [924, 4114], [912, 4136], [888, 4137], [860, 4100], [818, 4128], [814, 4164], [794, 4149], [797, 4115], [769, 4110], [754, 4175], [738, 4188], [731, 4219], [712, 4204], [678, 4220], [660, 4215], [610, 4238], [614, 4263], [638, 4293], [618, 4309], [588, 4291], [543, 4315], [533, 4338], [504, 4352], [491, 4384], [469, 4397], [474, 4425], [457, 4478], [417, 4494], [383, 4489], [368, 4476], [342, 4488], [318, 4560], [292, 4597], [274, 4590], [258, 4612], [231, 4617], [185, 4686], [161, 4710], [115, 4734], [123, 4758], [116, 4794], [58, 4812], [25, 4832], [0, 4818], [-16, 4831], [-40, 4781], [-70, 4757], [-88, 4764], [-101, 4821], [-135, 4844], [-143, 4862], [-211, 4912], [-239, 4921], [-221, 4955], [-250, 4976], [-286, 5024], [-336, 5030], [-365, 5056], [-380, 5082], [-389, 5131], [-409, 5161], [-431, 5139], [-476, 5153], [-474, 5193], [-447, 5209], [-467, 5252], [-443, 5292], [-484, 5363], [-476, 5404], [-484, 5432], [-434, 5433], [-416, 5442], [-414, 5401], [-392, 5371], [-361, 5368], [-349, 5389], [-317, 5386], [-272, 5412], [-262, 5434], [-283, 5487], [-265, 5532], [-333, 5581], [-357, 5643], [-345, 5685], [-340, 5763], [-288, 5783], [-285, 5812], [-234, 5824], [-176, 5818], [-125, 5798], [-83, 5848], [-85, 5904], [-50, 5919], [-53, 5936], [-15, 5967], [24, 6019], [50, 5989], [116, 5962], [136, 5945], [155, 5963], [179, 5941], [207, 5939], [238, 5914], [269, 5906], [326, 5912], [347, 5937], [389, 5952], [422, 5979], [472, 5960], [515, 5957], [513, 5914], [533, 5892], [561, 5889], [617, 5864], [674, 5856], [697, 5861], [739, 5847], [811, 5874], [852, 5876], [883, 5891], [927, 5897], [972, 5890], [1000, 5862], [1033, 5880], [1072, 5873], [1106, 5894], [1139, 5945], [1188, 5960], [1327, 5956], [1358, 5968], [1398, 5951], [1465, 5952], [1481, 5960], [1567, 5951], [1610, 5925], [1632, 5923], [1653, 5899], [1701, 5886], [1779, 5832], [1748, 5830], [1731, 5817], [1736, 5791], [1791, 5770], [1761, 5700], [1766, 5684], [1717, 5668], [1707, 5640], [1724, 5605], [1718, 5578], [1759, 5565], [1763, 5546], [1741, 5524], [1751, 5437], [1734, 5400], [1702, 5380], [1715, 5336], [1738, 5312], [1750, 5266], [1779, 5249], [1786, 5208], [1804, 5179], [1825, 5174], [1864, 5139], [1890, 5132], [1921, 5150], [1956, 5149], [1970, 5166], [2003, 5161], [2029, 5098], [2077, 5066], [2104, 5034], [2146, 5033], [2147, 5005], [2195, 5004], [2229, 4992], [2297, 4982], [2299, 4965], [2335, 4960], [2387, 4920], [2431, 4927], [2456, 4906], [2500, 4897], [2542, 4906], [2596, 4930], [2658, 4866], [2657, 4845], [2677, 4826], [2714, 4817], [2742, 4780], [2725, 4750], [2731, 4716], [2746, 4699], [2790, 4695], [2860, 4676], [2871, 4640], [2885, 4646], [2884, 4682], [2873, 4693], [2901, 4719], [2937, 4680], [2996, 4665], [2990, 4721], [3046, 4730], [3066, 4724], [3093, 4737], [3096, 4766], [3118, 4776], [3124, 4831], [3174, 4812], [3193, 4833], [3248, 4810], [3282, 4781], [3283, 4758], [3322, 4693], [3313, 4655], [3340, 4603], [3391, 4542], [3366, 4517], [3343, 4537], [3333, 4506], [3368, 4462], [3360, 4442], [3392, 4404], [3381, 4386], [3387, 4340], [3385, 4268], [3394, 4215], [3375, 4157], [3384, 4136], [3383, 4079], [3390, 4059]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.HH',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.43,
      'hc-middle-y': 0.54,
      'hc-key': 'tw-hh',
      'hc-a2': 'HH',
      'labelrank': '9',
      'hasc': 'TW.TW.HH',
      'alt-name': 'Xinzhu',
      'woe-id': '2347334',
      'subregion': null,
      'fips': null,
      'postal-code': 'HH',
      'name': 'Hsinchu',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '121.163',
      'woe-name': 'Hsinchu County',
      'latitude': '24.6748',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7744, 2944], [7760, 2958], [7733, 2974], [7741, 2986], [7744, 2996], [7757, 2997], [7813, 2957], [7811, 2934], [7837, 2921], [7832, 2904], [7819, 2885], [7817, 2885], [7808, 2883], [7796, 2902], [7768, 2897], [7769, 2918], [7744, 2944]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.CL',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.60,
      'hc-middle-y': 0.39,
      'hc-key': 'tw-cl',
      'hc-a2': 'CL',
      'labelrank': '9',
      'hasc': 'TW.TW.CL',
      'alt-name': 'Jilong Shi|Chilung City',
      'woe-id': '22695855',
      'subregion': null,
      'fips': null,
      'postal-code': 'CL',
      'name': 'Keelung City',
      'country': 'Taiwan',
      'type-en': 'Provincial City',
      'region': 'Taiwan Province',
      'longitude': '121.704',
      'woe-name': 'Keelung City',
      'latitude': '25.1131',
      'woe-label': null,
      'type': 'Shi'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7887, 3052], [7890, 3049], [7902, 3046], [7905, 3030], [7876, 3045], [7887, 3052]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.ML',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.49,
      'hc-middle-y': 0.60,
      'hc-key': 'tw-ml',
      'hc-a2': 'ML',
      'labelrank': '9',
      'hasc': 'TW.TW.ML',
      'alt-name': null,
      'woe-id': '2347338',
      'subregion': null,
      'fips': null,
      'postal-code': 'ML',
      'name': 'Miaoli',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '120.942',
      'woe-name': 'Miaoli County',
      'latitude': '24.5253',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7744, 2944], [7769, 2918], [7768, 2897], [7796, 2902], [7808, 2883], [7765, 2853], [7744, 2860], [7726, 2848], [7677, 2883], [7692, 2917], [7726, 2950], [7740, 2942], [7744, 2944]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.NX',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.51,
      'hc-middle-y': 0.43,
      'hc-key': 'cn-nx',
      'hc-a2': 'NX',
      'labelrank': '2',
      'hasc': 'CN.NX',
      'alt-name': 'Ningxia Hui|N铆ngxi脿 H煤iz煤',
      'woe-id': '12578010',
      'subregion': 'Western',
      'fips': 'CH21',
      'postal-code': 'NX',
      'name': '宁夏回族自治区',
      'country': 'China',
      'type-en': 'Autonomous Region',
      'region': 'Northwest China',
      'longitude': '106.038',
      'woe-name': 'Ningxia',
      'latitude': '37.1762',
      'woe-label': 'Ningxia, CN, China',
      'type': 'Z矛zh矛qu'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[5152, 5919], [5142, 5900], [5124, 5900], [5087, 5861], [5069, 5794], [5084, 5760], [5076, 5740], [5058, 5752], [5011, 5752], [4985, 5772], [4958, 5771], [4954, 5729], [4942, 5714], [4955, 5691], [4945, 5666], [4926, 5662], [4920, 5561], [4940, 5562], [4979, 5545], [5002, 5513], [4981, 5469], [4993, 5447], [4957, 5422], [4933, 5435], [4901, 5430], [4914, 5396], [4904, 5345], [4875, 5333], [4857, 5362], [4800, 5367], [4829, 5379], [4807, 5395], [4786, 5388], [4762, 5433], [4715, 5453], [4696, 5495], [4703, 5523], [4720, 5534], [4723, 5568], [4694, 5638], [4687, 5671], [4707, 5691], [4683, 5736], [4637, 5768], [4626, 5797], [4583, 5807], [4603, 5827], [4598, 5844], [4556, 5853], [4536, 5845], [4550, 5867], [4647, 5872], [4674, 5897], [4725, 5916], [4781, 5910], [4806, 5924], [4815, 5970], [4804, 6001], [4818, 6022], [4825, 6103], [4837, 6141], [4870, 6196], [4881, 6229], [4913, 6236], [4918, 6267], [4953, 6264], [4976, 6280], [5008, 6280], [5009, 6241], [5039, 6202], [5029, 6175], [4984, 6110], [4972, 6069], [4937, 6031], [5002, 5995], [5045, 5985], [5064, 5990], [5093, 5972], [5106, 5937], [5152, 5919]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.SA',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.54,
      'hc-middle-y': 0.75,
      'hc-key': 'cn-sa',
      'hc-a2': 'SA',
      'labelrank': '2',
      'hasc': 'CN.SA',
      'alt-name': 'Sh?nx?',
      'woe-id': '12578015',
      'subregion': 'Western',
      'fips': 'CH26',
      'postal-code': 'SA',
      'name': '陕西省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'Northwest China',
      'longitude': '108.363',
      'woe-name': 'Shaanxi',
      'latitude': '33.7713',
      'woe-label': 'Shaanxi, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[5076, 5740], [5084, 5760], [5069, 5794], [5087, 5861], [5124, 5900], [5142, 5900], [5152, 5919], [5202, 5902], [5221, 5865], [5275, 5864], [5356, 5872], [5360, 5924], [5371, 5943], [5393, 5928], [5408, 5971], [5395, 5992], [5402, 6023], [5435, 6071], [5464, 6088], [5485, 6123], [5506, 6126], [5533, 6178], [5560, 6188], [5587, 6217], [5626, 6240], [5615, 6274], [5636, 6273], [5656, 6247], [5685, 6260], [5711, 6229], [5750, 6280], [5781, 6303], [5800, 6306], [5785, 6269], [5798, 6260], [5818, 6242], [5798, 6185], [5775, 6171], [5771, 6127], [5750, 6082], [5746, 6043], [5682, 5985], [5681, 5927], [5723, 5882], [5730, 5834], [5700, 5796], [5706, 5770], [5680, 5738], [5649, 5680], [5661, 5641], [5652, 5631], [5669, 5610], [5660, 5506], [5670, 5447], [5679, 5438], [5689, 5380], [5634, 5289], [5618, 5231], [5615, 5166], [5631, 5155], [5628, 5124], [5656, 5088], [5647, 5073], [5682, 5050], [5686, 5008], [5676, 4985], [5705, 4967], [5713, 4945], [5746, 4920], [5754, 4868], [5746, 4844], [5715, 4828], [5703, 4806], [5674, 4819], [5664, 4841], [5641, 4825], [5603, 4822], [5577, 4835], [5494, 4849], [5466, 4844], [5454, 4824], [5511, 4807], [5507, 4772], [5538, 4768], [5575, 4750], [5588, 4700], [5555, 4685], [5532, 4695], [5485, 4696], [5470, 4654], [5455, 4643], [5476, 4610], [5488, 4571], [5476, 4545], [5472, 4502], [5421, 4496], [5369, 4551], [5318, 4577], [5267, 4613], [5260, 4625], [5213, 4630], [5177, 4623], [5167, 4606], [5137, 4625], [5103, 4663], [5064, 4669], [5063, 4695], [5015, 4681], [4990, 4698], [4991, 4740], [4924, 4750], [4902, 4736], [4829, 4721], [4797, 4750], [4808, 4783], [4764, 4782], [4750, 4762], [4704, 4759], [4692, 4800], [4719, 4793], [4768, 4812], [4776, 4870], [4745, 4885], [4740, 4907], [4763, 4931], [4811, 4956], [4829, 4942], [4872, 4953], [4891, 4935], [4903, 4947], [4890, 4971], [4881, 5017], [4900, 5064], [4915, 5070], [4910, 5103], [4929, 5096], [4934, 5126], [4902, 5159], [4877, 5160], [4868, 5175], [4903, 5209], [4915, 5237], [4906, 5276], [4920, 5286], [4987, 5286], [5012, 5273], [5041, 5238], [5062, 5248], [5095, 5243], [5109, 5252], [5158, 5253], [5131, 5311], [5145, 5332], [5186, 5308], [5223, 5322], [5286, 5316], [5311, 5343], [5309, 5379], [5293, 5415], [5291, 5456], [5327, 5484], [5332, 5511], [5323, 5535], [5334, 5565], [5317, 5583], [5286, 5591], [5271, 5611], [5212, 5625], [5185, 5663], [5150, 5680], [5074, 5704], [5076, 5740]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.TY',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.66,
      'hc-middle-y': 0.46,
      'hc-key': 'tw-ty',
      'hc-a2': 'TY',
      'labelrank': '9',
      'hasc': 'TW.TW.TY',
      'alt-name': null,
      'woe-id': '2347345',
      'subregion': null,
      'fips': null,
      'postal-code': 'TY',
      'name': 'Taoyuan',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '121.227',
      'woe-name': 'Taoyuan County',
      'latitude': '24.961',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7837, 2921], [7811, 2934], [7813, 2957], [7757, 2997], [7744, 2996], [7761, 3019], [7806, 3038], [7832, 3020], [7816, 3004], [7822, 2978], [7842, 2966], [7851, 2941], [7847, 2927], [7837, 2921]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.3682',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.53,
      'hc-middle-y': 0.42,
      'hc-key': 'cn-3682',
      'hc-a2': 'CA',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703128',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Central and Western',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'Hong Kong Island',
      'longitude': '114.144',
      'woe-name': 'Central and Western',
      'latitude': '22.2741',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6349, 2368], [6355, 2372], [6360, 2370], [6360, 2365], [6352, 2368], [6349, 2368]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.CG',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.56,
      'hc-middle-y': 0.48,
      'hc-key': 'tw-cg',
      'hc-a2': 'CG',
      'labelrank': '9',
      'hasc': 'TW.TW.CG',
      'alt-name': 'Zhanghua|Changhwa',
      'woe-id': '20070572',
      'subregion': null,
      'fips': null,
      'postal-code': 'CG',
      'name': 'Changhua',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '120.464',
      'woe-name': 'Changhua County',
      'latitude': '24.0016',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7606, 2742], [7624, 2784], [7650, 2826], [7674, 2805], [7691, 2786], [7685, 2769], [7689, 2731], [7634, 2742], [7606, 2742]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6655',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.50,
      'hc-key': 'cn-6655',
      'hc-a2': 'WC',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703129',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Wan Chai',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'Hong Kong Island',
      'longitude': '114.178',
      'woe-name': 'Wan Chai',
      'latitude': '22.2699',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6360, 2365], [6360, 2370], [6363, 2370], [6366, 2369], [6365, 2366], [6362, 2365], [6360, 2365]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.AH',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.44,
      'hc-middle-y': 0.59,
      'hc-key': 'cn-ah',
      'hc-a2': 'AH',
      'labelrank': '2',
      'hasc': 'CN.AH',
      'alt-name': '?nhu?',
      'woe-id': '12578022',
      'subregion': 'Central',
      'fips': 'CH01',
      'postal-code': 'AH',
      'name': '安徽省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'East China',
      'longitude': '117.253',
      'woe-name': 'Anhui',
      'latitude': '31.9537',
      'woe-label': 'Anhui, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6748, 4053], [6734, 4093], [6726, 4150], [6693, 4187], [6707, 4200], [6671, 4255], [6689, 4294], [6723, 4323], [6691, 4355], [6651, 4374], [6628, 4366], [6593, 4419], [6596, 4440], [6623, 4492], [6648, 4503], [6694, 4505], [6699, 4558], [6687, 4673], [6653, 4663], [6628, 4643], [6589, 4678], [6557, 4685], [6554, 4746], [6504, 4768], [6496, 4797], [6512, 4806], [6545, 4797], [6573, 4812], [6584, 4836], [6583, 4893], [6639, 4914], [6626, 4950], [6637, 4971], [6624, 4984], [6641, 5019], [6656, 5023], [6700, 5008], [6702, 4986], [6743, 4944], [6788, 4962], [6793, 4974], [6830, 4999], [6810, 5037], [6811, 5075], [6783, 5072], [6736, 5111], [6734, 5139], [6756, 5141], [6777, 5156], [6859, 5102], [6887, 5100], [6904, 5047], [6928, 5033], [6994, 5025], [7017, 5016], [7041, 4987], [7038, 4952], [7113, 4963], [7124, 4946], [7113, 4897], [7104, 4899], [7080, 4840], [7109, 4822], [7135, 4829], [7141, 4771], [7153, 4738], [7173, 4728], [7234, 4730], [7259, 4785], [7285, 4784], [7318, 4752], [7328, 4701], [7306, 4667], [7268, 4700], [7243, 4703], [7203, 4693], [7226, 4666], [7224, 4617], [7198, 4608], [7174, 4574], [7168, 4549], [7194, 4530], [7193, 4514], [7234, 4495], [7231, 4485], [7269, 4480], [7274, 4456], [7250, 4418], [7263, 4389], [7313, 4393], [7330, 4405], [7366, 4405], [7370, 4384], [7422, 4373], [7414, 4308], [7390, 4260], [7378, 4270], [7351, 4238], [7367, 4232], [7382, 4198], [7354, 4183], [7282, 4185], [7278, 4148], [7287, 4108], [7258, 4072], [7255, 4050], [7223, 4026], [7188, 3986], [7149, 3975], [7136, 3999], [7111, 4011], [7056, 4006], [7020, 4020], [6995, 4053], [6995, 4066], [6960, 4069], [6953, 4087], [6929, 4067], [6932, 4038], [6895, 4003], [6863, 4001], [6847, 4018], [6852, 4036], [6876, 4047], [6893, 4084], [6874, 4107], [6846, 4113], [6816, 4075], [6795, 4073], [6766, 4051], [6748, 4053]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.HU',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.55,
      'hc-middle-y': 0.52,
      'hc-key': 'cn-hu',
      'hc-a2': 'HU',
      'labelrank': '2',
      'hasc': 'CN.HU',
      'alt-name': 'H煤b?i',
      'woe-id': '12578002',
      'subregion': 'Central',
      'fips': 'CH12',
      'postal-code': 'HU',
      'name': '湖北省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'South Central China',
      'longitude': '112.264',
      'woe-name': 'Hubei',
      'latitude': '30.9857',
      'woe-label': 'Hubei, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6593, 4419], [6628, 4366], [6651, 4374], [6691, 4355], [6723, 4323], [6689, 4294], [6671, 4255], [6707, 4200], [6693, 4187], [6726, 4150], [6734, 4093], [6748, 4053], [6691, 4040], [6661, 4068], [6618, 4068], [6605, 4034], [6576, 4011], [6540, 4021], [6550, 4005], [6500, 3991], [6487, 3961], [6419, 3944], [6383, 3953], [6375, 3928], [6338, 3918], [6307, 3887], [6258, 3900], [6245, 3938], [6273, 3970], [6257, 4024], [6235, 4027], [6245, 4070], [6211, 4044], [6154, 3977], [6115, 3984], [6117, 4029], [6107, 4051], [6060, 4014], [6020, 4018], [5987, 3995], [5975, 4025], [5918, 4068], [5888, 4082], [5818, 4085], [5785, 4109], [5687, 4126], [5681, 4111], [5648, 4117], [5632, 4108], [5638, 4074], [5656, 4053], [5623, 4043], [5610, 4027], [5560, 4058], [5496, 4048], [5477, 4020], [5462, 4023], [5426, 4005], [5406, 3951], [5379, 3910], [5342, 3957], [5324, 3967], [5317, 4032], [5282, 4047], [5267, 4083], [5248, 4054], [5225, 4078], [5253, 4090], [5255, 4187], [5226, 4207], [5237, 4226], [5264, 4228], [5284, 4244], [5296, 4232], [5342, 4250], [5383, 4239], [5425, 4242], [5474, 4271], [5496, 4297], [5520, 4308], [5558, 4294], [5571, 4311], [5568, 4360], [5581, 4375], [5570, 4423], [5535, 4451], [5498, 4461], [5496, 4478], [5472, 4502], [5476, 4545], [5488, 4571], [5476, 4610], [5455, 4643], [5470, 4654], [5485, 4696], [5532, 4695], [5555, 4685], [5588, 4700], [5575, 4750], [5538, 4768], [5507, 4772], [5511, 4807], [5454, 4824], [5466, 4844], [5494, 4849], [5577, 4835], [5603, 4822], [5641, 4825], [5664, 4841], [5674, 4819], [5703, 4806], [5715, 4828], [5746, 4844], [5771, 4816], [5790, 4766], [5846, 4709], [5850, 4693], [5885, 4690], [5898, 4671], [5950, 4656], [5995, 4631], [6043, 4637], [6085, 4630], [6142, 4647], [6175, 4644], [6198, 4622], [6235, 4617], [6274, 4645], [6284, 4632], [6278, 4581], [6286, 4544], [6320, 4492], [6354, 4515], [6396, 4490], [6434, 4491], [6432, 4453], [6475, 4435], [6520, 4432], [6545, 4459], [6562, 4448], [6563, 4425], [6593, 4419]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.HL',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.51,
      'hc-middle-y': 0.48,
      'hc-key': 'tw-hl',
      'hc-a2': 'HL',
      'labelrank': '9',
      'hasc': 'TW.TW.HL',
      'alt-name': 'Hualian',
      'woe-id': '2347335',
      'subregion': null,
      'fips': null,
      'postal-code': 'HL',
      'name': '花莲县',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '121.381',
      'woe-name': 'Hualien County',
      'latitude': '23.7743',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7911, 2864], [7882, 2807], [7887, 2796], [7869, 2713], [7863, 2663], [7835, 2602], [7823, 2589], [7776, 2629], [7763, 2643], [7768, 2659], [7808, 2699], [7805, 2736], [7825, 2807], [7826, 2826], [7827, 2840], [7843, 2860], [7848, 2872], [7879, 2864], [7911, 2864]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.TH',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.08,
      'hc-middle-y': 0.51,
      'hc-key': 'tw-th',
      'hc-a2': 'TH',
      'labelrank': '9',
      'hasc': 'TW.TW.TG',
      'alt-name': 'Taizhong Shi',
      'woe-id': '28751584',
      'subregion': null,
      'fips': null,
      'postal-code': 'TH',
      'name': 'Taichung City',
      'country': 'Taiwan',
      'type-en': 'Special Municipality',
      'region': 'Special Municipalities',
      'longitude': '120.966',
      'woe-name': 'Taichung City',
      'latitude': '24.238',
      'woe-label': null,
      'type': 'Zhixiashi'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7827, 2840], [7791, 2836], [7754, 2812], [7723, 2807], [7715, 2789], [7691, 2786], [7674, 2805], [7650, 2826], [7667, 2871], [7677, 2883], [7726, 2848], [7744, 2860], [7765, 2853], [7808, 2883], [7817, 2885], [7819, 2885], [7823, 2877], [7848, 2872], [7843, 2860], [7827, 2840], [7827, 2840]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6656',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.51,
      'hc-middle-y': 0.37,
      'hc-key': 'cn-6656',
      'hc-a2': 'EA',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703131',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Eastern',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'Hong Kong Island',
      'longitude': '114.213',
      'woe-name': 'Eastern',
      'latitude': '22.2706',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6365, 2366], [6366, 2369], [6363, 2370], [6375, 2370], [6378, 2363], [6374, 2365], [6365, 2366]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.NT',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.46,
      'hc-middle-y': 0.46,
      'hc-key': 'tw-nt',
      'hc-a2': 'NT',
      'labelrank': '9',
      'hasc': 'TW.TW.NT',
      'alt-name': null,
      'woe-id': '2347339',
      'subregion': null,
      'fips': null,
      'postal-code': 'NT',
      'name': 'Nantou',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '120.988',
      'woe-name': 'Nantou County',
      'latitude': '23.7977',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7805, 2736], [7808, 2699], [7768, 2659], [7764, 2665], [7756, 2667], [7729, 2668], [7727, 2692], [7709, 2697], [7688, 2702], [7689, 2731], [7685, 2769], [7691, 2786], [7715, 2789], [7723, 2807], [7754, 2812], [7791, 2836], [7827, 2840], [7827, 2840], [7828, 2835], [7826, 2826], [7805, 2736]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6658',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.84,
      'hc-middle-y': 0.42,
      'hc-key': 'cn-6658',
      'hc-a2': 'YT',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703134',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Yau Tsim Mong',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'Kowloon',
      'longitude': '114.169',
      'woe-name': 'Yau Tsim Mong',
      'latitude': '22.3128',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6362, 2373], [6361, 2376], [6359, 2380], [6362, 2380], [6363, 2376], [6362, 2373]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6659',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.52,
      'hc-middle-y': 0.48,
      'hc-key': 'cn-6659',
      'hc-a2': 'KC',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703135',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Kowloon City',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'Kowloon',
      'longitude': '114.19',
      'woe-name': 'Kowloon City',
      'latitude': '22.3268',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6370, 2377], [6366, 2379], [6362, 2373], [6363, 2376], [6362, 2380], [6362, 2383], [6361, 2385], [6364, 2385], [6366, 2382], [6368, 2382], [6369, 2380], [6370, 2377]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.CQ',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.42,
      'hc-middle-y': 0.62,
      'hc-key': 'cn-cq',
      'hc-a2': 'CQ',
      'labelrank': '2',
      'hasc': 'CN.CQ',
      'alt-name': 'Ch贸ngq矛ng',
      'woe-id': '20070171',
      'subregion': 'Western',
      'fips': 'CH33',
      'postal-code': 'CQ',
      'name': '重庆市',
      'country': 'China',
      'type-en': 'Municipality',
      'region': 'Southwest China',
      'longitude': '107.73',
      'woe-name': 'Chongqing',
      'latitude': '30.0173',
      'woe-label': 'Chongqing, CN, China',
      'type': 'Zh铆xi谩sh矛'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[5379, 3910], [5392, 3897], [5377, 3803], [5385, 3775], [5364, 3760], [5351, 3708], [5278, 3719], [5290, 3760], [5262, 3768], [5269, 3741], [5250, 3750], [5252, 3801], [5202, 3822], [5210, 3842], [5197, 3910], [5151, 3908], [5115, 3892], [5098, 3905], [5098, 3927], [5054, 3940], [5042, 3954], [5026, 3916], [5041, 3897], [5027, 3871], [4989, 3857], [4973, 3874], [4947, 3877], [4932, 3856], [4910, 3853], [4909, 3827], [4876, 3789], [4850, 3802], [4864, 3824], [4853, 3854], [4834, 3867], [4844, 3833], [4836, 3804], [4815, 3812], [4800, 3835], [4794, 3880], [4746, 3906], [4719, 3895], [4694, 3913], [4688, 3965], [4633, 3995], [4615, 4024], [4612, 4050], [4637, 4076], [4664, 4082], [4667, 4097], [4697, 4110], [4705, 4147], [4671, 4174], [4707, 4204], [4720, 4234], [4784, 4213], [4805, 4184], [4865, 4208], [4880, 4191], [4897, 4143], [4959, 4140], [4999, 4179], [5030, 4237], [5051, 4261], [5048, 4295], [5059, 4309], [5101, 4322], [5118, 4301], [5142, 4317], [5158, 4354], [5165, 4395], [5197, 4419], [5204, 4449], [5240, 4470], [5263, 4502], [5260, 4521], [5220, 4552], [5217, 4564], [5247, 4591], [5236, 4607], [5267, 4613], [5318, 4577], [5369, 4551], [5421, 4496], [5472, 4502], [5496, 4478], [5498, 4461], [5535, 4451], [5570, 4423], [5581, 4375], [5568, 4360], [5571, 4311], [5558, 4294], [5520, 4308], [5496, 4297], [5474, 4271], [5425, 4242], [5383, 4239], [5342, 4250], [5296, 4232], [5284, 4244], [5264, 4228], [5237, 4226], [5226, 4207], [5255, 4187], [5253, 4090], [5225, 4078], [5248, 4054], [5267, 4083], [5282, 4047], [5317, 4032], [5324, 3967], [5342, 3957], [5379, 3910]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.HN',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.51,
      'hc-middle-y': 0.50,
      'hc-key': 'cn-hn',
      'hc-a2': 'HN',
      'labelrank': '2',
      'hasc': 'CN.HN',
      'alt-name': 'H煤n谩n',
      'woe-id': '12578001',
      'subregion': 'Central',
      'fips': 'CH11',
      'postal-code': 'HN',
      'name': '湖南省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'South Central China',
      'longitude': '111.712',
      'woe-name': 'Hunan',
      'latitude': '27.6667',
      'woe-label': 'Hunan, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[5385, 3775], [5377, 3803], [5392, 3897], [5379, 3910], [5406, 3951], [5426, 4005], [5462, 4023], [5477, 4020], [5496, 4048], [5560, 4058], [5610, 4027], [5623, 4043], [5656, 4053], [5638, 4074], [5632, 4108], [5648, 4117], [5681, 4111], [5687, 4126], [5785, 4109], [5818, 4085], [5888, 4082], [5918, 4068], [5975, 4025], [5987, 3995], [6020, 4018], [6060, 4014], [6107, 4051], [6117, 4029], [6115, 3984], [6154, 3977], [6211, 4044], [6245, 4070], [6235, 4027], [6257, 4024], [6273, 3970], [6245, 3938], [6258, 3900], [6307, 3887], [6307, 3862], [6354, 3824], [6348, 3786], [6337, 3774], [6361, 3761], [6371, 3739], [6363, 3713], [6344, 3705], [6329, 3671], [6309, 3652], [6273, 3643], [6266, 3607], [6238, 3556], [6246, 3506], [6259, 3497], [6296, 3501], [6277, 3455], [6304, 3411], [6292, 3385], [6299, 3346], [6343, 3329], [6340, 3301], [6311, 3238], [6359, 3249], [6369, 3238], [6334, 3215], [6330, 3185], [6307, 3144], [6322, 3106], [6311, 3076], [6291, 3056], [6241, 3049], [6167, 3089], [6104, 3048], [6100, 3031], [6126, 3032], [6116, 3017], [6120, 2969], [6083, 2964], [6054, 3003], [6013, 3014], [5957, 3012], [5944, 2967], [5948, 2932], [5918, 2920], [5903, 2929], [5851, 2931], [5820, 2900], [5802, 2909], [5811, 2934], [5803, 3004], [5772, 3014], [5742, 2991], [5722, 2964], [5707, 2988], [5715, 3016], [5740, 3035], [5751, 3063], [5782, 3093], [5780, 3124], [5810, 3187], [5776, 3173], [5759, 3195], [5772, 3267], [5711, 3293], [5697, 3267], [5666, 3268], [5632, 3283], [5628, 3257], [5588, 3233], [5568, 3204], [5546, 3221], [5525, 3218], [5531, 3243], [5505, 3254], [5472, 3190], [5452, 3187], [5438, 3224], [5409, 3221], [5399, 3273], [5378, 3283], [5401, 3333], [5380, 3376], [5427, 3404], [5412, 3414], [5425, 3431], [5412, 3466], [5370, 3472], [5355, 3456], [5343, 3468], [5313, 3445], [5282, 3459], [5368, 3537], [5382, 3535], [5411, 3562], [5417, 3582], [5400, 3607], [5390, 3673], [5402, 3720], [5385, 3734], [5385, 3775]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.YL',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.44,
      'hc-middle-y': 0.38,
      'hc-key': 'tw-yl',
      'hc-a2': 'YL',
      'labelrank': '9',
      'hasc': 'TW.TW.YL',
      'alt-name': 'Y眉anlin',
      'woe-id': '2347346',
      'subregion': null,
      'fips': null,
      'postal-code': 'YL',
      'name': 'Yunlin',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '120.427',
      'woe-name': 'Yunlin County',
      'latitude': '23.7253',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7689, 2731], [7688, 2702], [7709, 2697], [7677, 2689], [7638, 2696], [7607, 2671], [7584, 2670], [7595, 2728], [7606, 2742], [7634, 2742], [7689, 2731]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6660',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.61,
      'hc-middle-y': 0.37,
      'hc-key': 'cn-6660',
      'hc-a2': 'SS',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703133',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Sham Shui Po',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'Kowloon',
      'longitude': '114.164',
      'woe-name': 'Sham Shui Po',
      'latitude': '22.3331',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'MultiPolygon',
      'coordinates': [[[[6355, 2378], [6356, 2378], [6354, 2378], [6355, 2378]]], [[[6362, 2380], [6359, 2380], [6357, 2381], [6356, 2382], [6357, 2383], [6359, 2384], [6361, 2385], [6362, 2383], [6362, 2380]]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6661',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.66,
      'hc-key': 'cn-6661',
      'hc-a2': 'WT',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703137',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Wong Tai Sin',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'Kowloon',
      'longitude': '114.215',
      'woe-name': 'Wong Tai Sin',
      'latitude': '22.3432',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6368, 2382], [6366, 2382], [6364, 2385], [6372, 2387], [6374, 2382], [6368, 2382]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6662',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.61,
      'hc-middle-y': 0.47,
      'hc-key': 'cn-6662',
      'hc-a2': 'KT',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703136',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Kwun Tong',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'Kowloon',
      'longitude': '114.225',
      'woe-name': 'Kwun Tong',
      'latitude': '22.3159',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6376, 2372], [6375, 2371], [6370, 2377], [6369, 2380], [6368, 2382], [6374, 2382], [6376, 2379], [6376, 2372]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6664',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.52,
      'hc-middle-y': 0.48,
      'hc-key': 'cn-6664',
      'hc-a2': 'ST',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703138',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Sha Tin',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'The New Territories',
      'longitude': '114.2',
      'woe-name': 'Sha Tin',
      'latitude': '22.3807',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6378, 2396], [6375, 2392], [6372, 2387], [6364, 2385], [6361, 2385], [6359, 2384], [6358, 2387], [6357, 2389], [6362, 2396], [6361, 2401], [6364, 2401], [6368, 2402], [6371, 2397], [6378, 2404], [6378, 2400], [6378, 2396]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.6668',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.52,
      'hc-middle-y': 0.58,
      'hc-key': 'cn-6668',
      'hc-a2': 'YL',
      'labelrank': '20',
      'hasc': 'HK.',
      'alt-name': null,
      'woe-id': '24703143',
      'subregion': null,
      'fips': null,
      'postal-code': null,
      'name': 'Yuen Long',
      'country': 'Hong Kong S.A.R.',
      'type-en': null,
      'region': 'The New Territories',
      'longitude': '114.058',
      'woe-name': 'Yuen Long',
      'latitude': '22.4415',
      'woe-label': null,
      'type': null
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6354, 2399], [6341, 2396], [6333, 2393], [6323, 2398], [6314, 2403], [6326, 2417], [6344, 2424], [6347, 2413], [6355, 2412], [6352, 2408], [6354, 2399]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.PT',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.50,
      'hc-key': 'tw-pt',
      'hc-a2': 'PT',
      'labelrank': '9',
      'hasc': 'TW.TW.PT',
      'alt-name': 'Pingdong',
      'woe-id': '2347340',
      'subregion': null,
      'fips': null,
      'postal-code': 'PT',
      'name': '台东市',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '120.661',
      'woe-name': 'Pingtung County',
      'latitude': '22.5344',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7750, 2391], [7746, 2317], [7717, 2325], [7714, 2362], [7686, 2419], [7652, 2442], [7661, 2521], [7715, 2535], [7740, 2529], [7749, 2498], [7721, 2471], [7724, 2419], [7750, 2391]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.TT',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.10,
      'hc-middle-y': 0.72,
      'hc-key': 'tw-tt',
      'hc-a2': 'TT',
      'labelrank': '9',
      'hasc': 'TW.TW.TT',
      'alt-name': 'Taidong',
      'woe-id': '2347344',
      'subregion': null,
      'fips': null,
      'postal-code': 'TT',
      'name': '台东市',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '121.54',
      'woe-name': 'Taitung County',
      'latitude': '22.0499',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7750, 2391], [7724, 2419], [7721, 2471], [7749, 2498], [7740, 2529], [7750, 2615], [7776, 2629], [7823, 2589], [7835, 2602], [7863, 2663], [7849, 2598], [7800, 2506], [7776, 2484], [7751, 2420], [7750, 2391]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.TN',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.42,
      'hc-middle-y': 0.48,
      'hc-key': 'tw-tn',
      'hc-a2': 'TN',
      'labelrank': '9',
      'hasc': 'TW.TW.TN',
      'alt-name': 'Tainan Shi',
      'woe-id': '28751581',
      'subregion': null,
      'fips': null,
      'postal-code': 'TN',
      'name': 'Tainan City',
      'country': 'Taiwan',
      'type-en': 'Special Municipality',
      'region': 'Special Municipalities',
      'longitude': '120.182',
      'woe-name': 'Tainan City',
      'latitude': '23.0464',
      'woe-label': null,
      'type': 'Zhixiashi'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7695, 2610], [7651, 2543], [7635, 2533], [7598, 2540], [7574, 2588], [7584, 2625], [7601, 2622], [7625, 2643], [7649, 2649], [7669, 2631], [7675, 2608], [7695, 2610]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.BJ',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.48,
      'hc-middle-y': 0.54,
      'hc-key': 'cn-bj',
      'hc-a2': 'BJ',
      'labelrank': '7',
      'hasc': 'CN.BJ',
      'alt-name': 'B?ij?ng',
      'woe-id': '12578011',
      'subregion': null,
      'fips': 'CH22',
      'postal-code': 'BJ',
      'name': '北京市',
      'country': 'China',
      'type-en': 'Municipality',
      'region': 'North China',
      'longitude': '116.389',
      'woe-name': 'Beijing',
      'latitude': '39.9488',
      'woe-label': 'Beijing, CN, China',
      'type': 'Zh铆xi谩sh矛'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6915, 6429], [6869, 6414], [6828, 6408], [6832, 6379], [6860, 6359], [6850, 6331], [6841, 6315], [6836, 6311], [6801, 6313], [6769, 6291], [6762, 6272], [6729, 6302], [6681, 6303], [6647, 6286], [6621, 6309], [6593, 6318], [6590, 6350], [6611, 6357], [6586, 6393], [6613, 6425], [6661, 6441], [6679, 6472], [6639, 6530], [6665, 6547], [6687, 6544], [6725, 6581], [6770, 6592], [6751, 6618], [6769, 6618], [6804, 6649], [6809, 6628], [6852, 6583], [6879, 6567], [6957, 6564], [6944, 6549], [6913, 6542], [6903, 6524], [6916, 6487], [6935, 6468], [6928, 6433], [6915, 6429]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.HB',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.29,
      'hc-middle-y': 0.70,
      'hc-key': 'cn-hb',
      'hc-a2': 'HB',
      'labelrank': '2',
      'hasc': 'CN.HB',
      'alt-name': 'H茅b?i',
      'woe-id': '12578000',
      'subregion': null,
      'fips': 'CH10',
      'postal-code': 'HB',
      'name': '河北省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'North China',
      'longitude': '115.314',
      'woe-name': 'Hebei',
      'latitude': '38.5205',
      'woe-label': 'Hebei, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'MultiPolygon',
      'coordinates': [[[[6850, 6331], [6860, 6359], [6832, 6379], [6828, 6408], [6869, 6414], [6915, 6429], [6899, 6394], [6919, 6374], [6901, 6316], [6850, 6331]]], [[[6978, 6083], [7011, 6027], [7034, 6002], [7007, 5955], [6985, 5949], [6959, 5902], [6845, 5898], [6775, 5812], [6762, 5845], [6738, 5808], [6745, 5791], [6693, 5775], [6671, 5713], [6629, 5651], [6602, 5642], [6565, 5577], [6600, 5504], [6569, 5487], [6559, 5504], [6533, 5509], [6509, 5481], [6493, 5494], [6429, 5498], [6390, 5523], [6355, 5523], [6324, 5549], [6274, 5548], [6239, 5578], [6224, 5637], [6253, 5644], [6266, 5668], [6284, 5672], [6280, 5724], [6336, 5814], [6345, 5860], [6331, 5872], [6287, 5966], [6241, 5990], [6240, 6056], [6294, 6120], [6282, 6144], [6299, 6182], [6328, 6193], [6366, 6181], [6398, 6205], [6403, 6236], [6425, 6290], [6399, 6320], [6396, 6368], [6342, 6381], [6314, 6404], [6341, 6444], [6419, 6478], [6378, 6490], [6373, 6531], [6354, 6577], [6329, 6620], [6294, 6661], [6319, 6675], [6310, 6708], [6313, 6738], [6331, 6765], [6361, 6780], [6372, 6844], [6401, 6867], [6412, 6895], [6432, 6911], [6470, 6920], [6491, 6862], [6483, 6832], [6486, 6784], [6546, 6779], [6567, 6786], [6566, 6811], [6609, 6828], [6659, 6862], [6673, 6862], [6691, 6832], [6751, 6883], [6791, 6863], [6837, 6886], [6840, 6935], [6830, 6956], [6841, 6977], [6871, 6994], [6934, 6994], [6954, 7033], [6966, 7017], [7000, 7032], [7044, 6978], [7038, 6939], [7056, 6930], [7065, 6892], [7089, 6905], [7100, 6855], [7093, 6828], [7072, 6819], [7101, 6784], [7109, 6729], [7177, 6733], [7253, 6727], [7268, 6719], [7256, 6695], [7217, 6657], [7203, 6609], [7242, 6570], [7265, 6582], [7265, 6563], [7285, 6542], [7333, 6546], [7349, 6468], [7369, 6468], [7369, 6443], [7390, 6417], [7334, 6392], [7299, 6350], [7286, 6297], [7295, 6283], [7244, 6224], [7215, 6227], [7204, 6214], [7155, 6212], [7162, 6178], [7154, 6158], [7145, 6199], [7122, 6183], [7102, 6188], [7084, 6215], [7060, 6225], [7059, 6255], [7038, 6267], [7037, 6306], [6986, 6311], [6970, 6349], [6963, 6405], [7011, 6400], [7008, 6424], [6935, 6468], [6916, 6487], [6903, 6524], [6913, 6542], [6944, 6549], [6957, 6564], [6879, 6567], [6852, 6583], [6809, 6628], [6804, 6649], [6769, 6618], [6751, 6618], [6770, 6592], [6725, 6581], [6687, 6544], [6665, 6547], [6639, 6530], [6679, 6472], [6661, 6441], [6613, 6425], [6586, 6393], [6611, 6357], [6590, 6350], [6593, 6318], [6621, 6309], [6647, 6286], [6681, 6303], [6729, 6302], [6762, 6272], [6769, 6291], [6801, 6313], [6836, 6311], [6848, 6250], [6845, 6214], [6856, 6194], [6823, 6172], [6824, 6127], [6856, 6099], [6881, 6102], [6895, 6079], [6928, 6068], [6978, 6083]]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.IL',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.57,
      'hc-middle-y': 0.47,
      'hc-key': 'tw-il',
      'hc-a2': 'IL',
      'labelrank': '9',
      'hasc': 'TW.TW.IL',
      'alt-name': 'Ilan',
      'woe-id': '2347336',
      'subregion': null,
      'fips': null,
      'postal-code': 'IL',
      'name': 'Yilan',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '121.644',
      'woe-name': 'Yilan County',
      'latitude': '24.5913',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7819, 2885], [7832, 2904], [7837, 2921], [7847, 2927], [7851, 2941], [7873, 2965], [7908, 2986], [7921, 3007], [7947, 3014], [7915, 2972], [7925, 2900], [7911, 2864], [7879, 2864], [7848, 2872], [7823, 2877], [7819, 2885]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.TP',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.43,
      'hc-middle-y': 0.39,
      'hc-key': 'tw-tp',
      'hc-a2': 'TP',
      'labelrank': '9',
      'hasc': 'TW.TW.TP',
      'alt-name': 'Xinbei Shi',
      'woe-id': '20070569',
      'subregion': null,
      'fips': 'TW03',
      'postal-code': 'TP',
      'name': '新台北市',
      'country': 'Taiwan',
      'type-en': 'Special Municipality',
      'region': 'Special Municipalities',
      'longitude': '121.646',
      'woe-name': 'Taipei County',
      'latitude': '24.911',
      'woe-label': null,
      'type': 'Zhixiashi'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7902, 3046], [7929, 3041], [7947, 3014], [7921, 3007], [7908, 2986], [7873, 2965], [7851, 2941], [7842, 2966], [7822, 2978], [7816, 3004], [7832, 3020], [7806, 3038], [7831, 3046], [7835, 3065], [7868, 3073], [7887, 3052], [7876, 3045], [7905, 3030], [7902, 3046]], [[7875, 3008], [7882, 3019], [7862, 3059], [7842, 3038], [7864, 3007], [7875, 3008]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.SD',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.37,
      'hc-middle-y': 0.52,
      'hc-key': 'cn-sd',
      'hc-a2': 'SD',
      'labelrank': '2',
      'hasc': 'CN.SD',
      'alt-name': 'Sh?nd?ng',
      'woe-id': '12578014',
      'subregion': null,
      'fips': 'CH25',
      'postal-code': 'SD',
      'name': '山东省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'East China',
      'longitude': '118.114',
      'woe-name': 'Shandong',
      'latitude': '36.3271',
      'woe-label': 'Shandong, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6777, 5156], [6756, 5141], [6734, 5139], [6722, 5150], [6671, 5139], [6619, 5140], [6598, 5162], [6597, 5186], [6556, 5198], [6548, 5223], [6515, 5238], [6484, 5239], [6487, 5277], [6504, 5286], [6527, 5324], [6557, 5332], [6607, 5393], [6630, 5405], [6676, 5451], [6708, 5460], [6716, 5492], [6688, 5473], [6598, 5444], [6576, 5415], [6577, 5451], [6593, 5466], [6600, 5504], [6565, 5577], [6602, 5642], [6629, 5651], [6671, 5713], [6693, 5775], [6745, 5791], [6738, 5808], [6762, 5845], [6775, 5812], [6845, 5898], [6959, 5902], [6985, 5949], [7007, 5955], [7034, 6002], [7080, 5973], [7104, 5975], [7165, 5958], [7185, 5977], [7220, 5980], [7273, 5911], [7297, 5893], [7300, 5870], [7259, 5880], [7249, 5854], [7244, 5800], [7250, 5777], [7283, 5755], [7339, 5743], [7400, 5752], [7422, 5776], [7414, 5801], [7451, 5821], [7494, 5860], [7495, 5875], [7573, 5918], [7608, 5916], [7629, 5892], [7648, 5890], [7659, 5861], [7693, 5871], [7714, 5839], [7735, 5830], [7799, 5842], [7832, 5867], [7845, 5834], [7939, 5837], [7918, 5820], [7931, 5786], [7909, 5776], [7892, 5740], [7916, 5747], [7914, 5727], [7878, 5697], [7852, 5702], [7867, 5714], [7824, 5732], [7750, 5692], [7751, 5673], [7717, 5674], [7663, 5651], [7640, 5631], [7606, 5644], [7626, 5600], [7611, 5581], [7589, 5599], [7570, 5566], [7582, 5525], [7518, 5499], [7507, 5503], [7518, 5534], [7473, 5536], [7470, 5510], [7488, 5476], [7461, 5451], [7455, 5424], [7443, 5431], [7438, 5400], [7420, 5404], [7390, 5389], [7373, 5341], [7350, 5327], [7339, 5275], [7324, 5269], [7304, 5276], [7286, 5262], [7246, 5258], [7228, 5191], [7214, 5176], [7175, 5176], [7160, 5119], [7118, 5108], [7114, 5142], [7094, 5165], [7045, 5164], [7042, 5135], [6985, 5122], [6959, 5147], [6930, 5115], [6906, 5174], [6883, 5213], [6861, 5230], [6794, 5216], [6777, 5156]]]
    }
  }, {
    'type': 'Feature',
    'id': 'TW.CH',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.50,
      'hc-key': 'tw-ch',
      'hc-a2': 'CH',
      'labelrank': '9',
      'hasc': 'TW.TW.CH',
      'alt-name': 'Jiayi|Chiai',
      'woe-id': '7153409',
      'subregion': null,
      'fips': null,
      'postal-code': 'CH',
      'name': 'Chiayi',
      'country': 'Taiwan',
      'type-en': 'County',
      'region': 'Taiwan Province',
      'longitude': '120.26',
      'woe-name': 'Chiayi County',
      'latitude': '23.4465',
      'woe-label': null,
      'type': 'Hsien'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7756, 2667], [7705, 2625], [7695, 2610], [7695, 2610], [7675, 2608], [7669, 2631], [7649, 2649], [7625, 2643], [7601, 2622], [7584, 2625], [7593, 2635], [7584, 2670], [7607, 2671], [7638, 2696], [7677, 2689], [7709, 2697], [7727, 2692], [7729, 2668], [7756, 2667]], [[7638, 2670], [7652, 2656], [7663, 2661], [7651, 2672], [7638, 2670]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.TJ',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.80,
      'hc-middle-y': 0.63,
      'hc-key': 'cn-tj',
      'hc-a2': 'TJ',
      'labelrank': '7',
      'hasc': 'CN.TJ',
      'alt-name': 'Ti?nj?n',
      'woe-id': '12578017',
      'subregion': null,
      'fips': 'CH28',
      'postal-code': 'TJ',
      'name': '天津市',
      'country': 'China',
      'type-en': 'Municipality',
      'region': 'North China',
      'longitude': '117.347',
      'woe-name': 'Tianjin',
      'latitude': '39.3708',
      'woe-label': 'Tianjin, CN, China',
      'type': 'Zh铆xi谩sh矛'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6978, 6083], [6928, 6068], [6895, 6079], [6881, 6102], [6856, 6099], [6824, 6127], [6823, 6172], [6856, 6194], [6845, 6214], [6848, 6250], [6836, 6311], [6841, 6315], [6850, 6331], [6901, 6316], [6919, 6374], [6899, 6394], [6915, 6429], [6928, 6433], [6935, 6468], [7008, 6424], [7011, 6400], [6963, 6405], [6970, 6349], [6986, 6311], [7037, 6306], [7038, 6267], [7059, 6255], [7060, 6225], [7037, 6221], [7007, 6199], [7028, 6169], [7011, 6164], [6984, 6128], [6978, 6083]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.HA',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.38,
      'hc-middle-y': 0.58,
      'hc-key': 'cn-ha',
      'hc-a2': 'HA',
      'labelrank': '2',
      'hasc': 'CN.HA',
      'alt-name': 'H?in谩n',
      'woe-id': '12578020',
      'subregion': null,
      'fips': 'CH31',
      'postal-code': 'HA',
      'name': '海南省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'South Central China',
      'longitude': '109.825',
      'woe-name': 'Hainan',
      'latitude': '19.1865',
      'woe-label': 'Hainan, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[5482, 1852], [5518, 1887], [5540, 1879], [5566, 1889], [5603, 1867], [5610, 1894], [5628, 1906], [5650, 1872], [5681, 1868], [5693, 1799], [5667, 1767], [5623, 1733], [5587, 1627], [5570, 1609], [5568, 1578], [5535, 1576], [5498, 1548], [5487, 1515], [5474, 1527], [5422, 1518], [5417, 1497], [5381, 1468], [5356, 1496], [5297, 1497], [5220, 1544], [5199, 1549], [5201, 1597], [5187, 1623], [5194, 1642], [5187, 1682], [5191, 1721], [5275, 1790], [5316, 1815], [5337, 1813], [5330, 1832], [5308, 1817], [5308, 1835], [5338, 1860], [5371, 1839], [5385, 1865], [5426, 1877], [5450, 1859], [5473, 1872], [5482, 1852]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.JL',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.47,
      'hc-middle-y': 0.52,
      'hc-key': 'cn-jl',
      'hc-a2': 'JL',
      'labelrank': '2',
      'hasc': 'CN.JL',
      'alt-name': 'J铆l铆n',
      'woe-id': '12577995',
      'subregion': 'Northeast',
      'fips': 'CH05',
      'postal-code': 'JL',
      'name': '吉林省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'Northeast China',
      'longitude': '126.466',
      'woe-name': 'Jilin',
      'latitude': '43.2978',
      'woe-label': 'Jilin, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[9369, 7396], [9377, 7375], [9351, 7290], [9357, 7259], [9339, 7242], [9300, 7242], [9239, 7204], [9274, 7167], [9226, 7182], [9210, 7203], [9205, 7241], [9180, 7243], [9182, 7258], [9135, 7248], [9124, 7195], [9121, 7121], [9101, 7120], [9093, 7100], [9057, 7115], [9041, 7098], [9039, 7059], [8989, 7008], [8956, 7010], [8918, 6994], [8874, 6999], [8834, 6986], [8838, 6959], [8863, 6920], [8891, 6892], [8867, 6840], [8839, 6861], [8813, 6849], [8775, 6845], [8757, 6858], [8708, 6857], [8675, 6881], [8641, 6923], [8618, 6896], [8588, 6886], [8571, 6830], [8534, 6757], [8514, 6743], [8494, 6698], [8439, 6682], [8415, 6693], [8434, 6716], [8445, 6749], [8438, 6774], [8421, 6783], [8384, 6849], [8379, 6874], [8353, 6872], [8346, 6938], [8376, 6987], [8349, 6988], [8323, 7045], [8303, 7064], [8300, 7084], [8275, 7101], [8278, 7119], [8253, 7156], [8255, 7205], [8233, 7208], [8212, 7170], [8187, 7143], [8165, 7181], [8172, 7198], [8146, 7231], [8096, 7248], [8048, 7285], [8040, 7256], [7983, 7276], [7987, 7317], [8001, 7311], [8005, 7337], [7964, 7419], [7969, 7446], [7951, 7458], [7923, 7505], [7918, 7536], [7854, 7484], [7796, 7453], [7774, 7458], [7777, 7503], [7732, 7566], [7721, 7669], [7751, 7691], [7758, 7713], [7739, 7752], [7719, 7760], [7701, 7810], [7665, 7806], [7651, 7820], [7677, 7864], [7669, 7888], [7708, 7882], [7752, 7843], [7778, 7878], [7796, 7848], [7834, 7823], [7845, 7842], [7845, 7916], [7891, 7924], [7906, 7952], [8008, 7968], [8041, 7978], [8059, 7911], [8049, 7894], [8066, 7875], [8061, 7848], [8083, 7817], [8098, 7819], [8127, 7777], [8160, 7768], [8164, 7779], [8213, 7780], [8216, 7800], [8239, 7794], [8254, 7770], [8301, 7774], [8310, 7794], [8355, 7806], [8359, 7768], [8385, 7739], [8440, 7721], [8509, 7752], [8551, 7731], [8580, 7730], [8605, 7683], [8590, 7655], [8606, 7600], [8623, 7615], [8646, 7607], [8663, 7617], [8697, 7601], [8688, 7561], [8732, 7503], [8758, 7480], [8792, 7500], [8786, 7552], [8805, 7557], [8813, 7579], [8838, 7596], [8849, 7584], [8861, 7513], [8921, 7432], [8926, 7410], [8951, 7375], [8974, 7373], [9010, 7393], [9010, 7437], [9058, 7462], [9096, 7467], [9120, 7505], [9137, 7497], [9145, 7467], [9158, 7466], [9186, 7498], [9196, 7490], [9217, 7429], [9249, 7422], [9288, 7398], [9297, 7383], [9323, 7400], [9352, 7386], [9369, 7396]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.QH',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.49,
      'hc-key': 'cn-qh',
      'hc-a2': 'QH',
      'labelrank': '2',
      'hasc': 'CN.QH',
      'alt-name': null,
      'woe-id': '12577996',
      'subregion': 'Western',
      'fips': null,
      'postal-code': 'QH',
      'name': '青海省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'Northwest China',
      'longitude': '96.2377',
      'woe-name': 'Qinghai',
      'latitude': '35.2652',
      'woe-label': 'Qinghai, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[1779, 5832], [1813, 5822], [1834, 5828], [1847, 5861], [1871, 5829], [1955, 5812], [1999, 5780], [2045, 5790], [2052, 5805], [2040, 5891], [2004, 5909], [1987, 5945], [1996, 5972], [2016, 5990], [2063, 5991], [2108, 6001], [2117, 6024], [2105, 6044], [2085, 6116], [1978, 6200], [1986, 6250], [1952, 6333], [1948, 6359], [1979, 6362], [2043, 6390], [2048, 6401], [2114, 6398], [2167, 6401], [2205, 6413], [2278, 6416], [2348, 6433], [2366, 6445], [2478, 6455], [2541, 6455], [2585, 6469], [2626, 6472], [2659, 6463], [2698, 6467], [2764, 6458], [2864, 6405], [2910, 6408], [2934, 6373], [2953, 6363], [2977, 6327], [3026, 6293], [3033, 6275], [3079, 6257], [3111, 6235], [3111, 6217], [3169, 6183], [3188, 6182], [3212, 6330], [3209, 6355], [3223, 6376], [3284, 6359], [3341, 6313], [3411, 6266], [3456, 6311], [3476, 6294], [3505, 6289], [3540, 6314], [3595, 6282], [3594, 6266], [3661, 6192], [3670, 6171], [3712, 6132], [3747, 6117], [3774, 6090], [3764, 6134], [3777, 6155], [3813, 6110], [3848, 6094], [3860, 6058], [3934, 6019], [3975, 5977], [4061, 5905], [4093, 5952], [4114, 5908], [4106, 5892], [4176, 5840], [4197, 5812], [4177, 5765], [4214, 5726], [4200, 5694], [4227, 5655], [4233, 5615], [4273, 5586], [4251, 5558], [4262, 5535], [4255, 5499], [4203, 5504], [4203, 5453], [4195, 5429], [4167, 5436], [4145, 5415], [4119, 5410], [4112, 5381], [4132, 5362], [4109, 5330], [4058, 5307], [4039, 5273], [4006, 5256], [4012, 5239], [4035, 5244], [4042, 5220], [4077, 5203], [4086, 5169], [4029, 5123], [3999, 5110], [3970, 5141], [3863, 5184], [3845, 5196], [3820, 5177], [3813, 5145], [3839, 5091], [3872, 5071], [3874, 5028], [3910, 5019], [3939, 5032], [3958, 4986], [3990, 4988], [3964, 4942], [3975, 4929], [3957, 4898], [3921, 4926], [3865, 4906], [3855, 4863], [3873, 4843], [3858, 4806], [3806, 4797], [3763, 4812], [3745, 4761], [3730, 4751], [3721, 4771], [3739, 4787], [3712, 4834], [3683, 4829], [3676, 4809], [3656, 4818], [3666, 4843], [3648, 4880], [3614, 4904], [3594, 4881], [3577, 4842], [3543, 4866], [3502, 4882], [3492, 4908], [3424, 4955], [3412, 4985], [3409, 5029], [3391, 5059], [3396, 5073], [3364, 5113], [3334, 5118], [3319, 5141], [3286, 5149], [3229, 5133], [3223, 5166], [3205, 5150], [3160, 5141], [3156, 5082], [3180, 5043], [3214, 5029], [3167, 4985], [3163, 4947], [3133, 4920], [3142, 4874], [3193, 4833], [3174, 4812], [3124, 4831], [3118, 4776], [3096, 4766], [3093, 4737], [3066, 4724], [3046, 4730], [2990, 4721], [2996, 4665], [2937, 4680], [2901, 4719], [2873, 4693], [2884, 4682], [2885, 4646], [2871, 4640], [2860, 4676], [2790, 4695], [2746, 4699], [2731, 4716], [2725, 4750], [2742, 4780], [2714, 4817], [2677, 4826], [2657, 4845], [2658, 4866], [2596, 4930], [2542, 4906], [2500, 4897], [2456, 4906], [2431, 4927], [2387, 4920], [2335, 4960], [2299, 4965], [2297, 4982], [2229, 4992], [2195, 5004], [2147, 5005], [2146, 5033], [2104, 5034], [2077, 5066], [2029, 5098], [2003, 5161], [1970, 5166], [1956, 5149], [1921, 5150], [1890, 5132], [1864, 5139], [1825, 5174], [1804, 5179], [1786, 5208], [1779, 5249], [1750, 5266], [1738, 5312], [1715, 5336], [1702, 5380], [1734, 5400], [1751, 5437], [1741, 5524], [1763, 5546], [1759, 5565], [1718, 5578], [1724, 5605], [1707, 5640], [1717, 5668], [1766, 5684], [1761, 5700], [1791, 5770], [1736, 5791], [1731, 5817], [1748, 5830], [1779, 5832]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.XJ',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.54,
      'hc-middle-y': 0.55,
      'hc-key': 'cn-xj',
      'hc-a2': 'XJ',
      'labelrank': '2',
      'hasc': 'CN.XJ',
      'alt-name': 'Xinjiang Uygur|X?nji?ng W茅iw煤?r',
      'woe-id': '12578003',
      'subregion': 'Western',
      'fips': 'CH13',
      'postal-code': 'XJ',
      'name': '新疆维吾尔自治区',
      'country': 'China',
      'type-en': 'Autonomous Region',
      'region': 'Northwest China',
      'longitude': '85.42529999999999',
      'woe-name': 'Xinjiang',
      'latitude': '41.122',
      'woe-label': 'Xinjiang, CN, China',
      'type': 'Z矛zh矛qu'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[2478, 6455], [2366, 6445], [2348, 6433], [2278, 6416], [2205, 6413], [2167, 6401], [2114, 6398], [2048, 6401], [2043, 6390], [1979, 6362], [1948, 6359], [1952, 6333], [1986, 6250], [1978, 6200], [2085, 6116], [2105, 6044], [2117, 6024], [2108, 6001], [2063, 5991], [2016, 5990], [1996, 5972], [1987, 5945], [2004, 5909], [2040, 5891], [2052, 5805], [2045, 5790], [1999, 5780], [1955, 5812], [1871, 5829], [1847, 5861], [1834, 5828], [1813, 5822], [1779, 5832], [1701, 5886], [1653, 5899], [1632, 5923], [1610, 5925], [1567, 5951], [1481, 5960], [1465, 5952], [1398, 5951], [1358, 5968], [1327, 5956], [1188, 5960], [1139, 5945], [1106, 5894], [1072, 5873], [1033, 5880], [1000, 5862], [972, 5890], [927, 5897], [883, 5891], [852, 5876], [811, 5874], [739, 5847], [697, 5861], [674, 5856], [617, 5864], [561, 5889], [533, 5892], [513, 5914], [515, 5957], [472, 5960], [422, 5979], [389, 5952], [347, 5937], [326, 5912], [269, 5906], [238, 5914], [207, 5939], [179, 5941], [155, 5963], [136, 5945], [116, 5962], [50, 5989], [24, 6019], [-15, 5967], [-53, 5936], [-50, 5919], [-85, 5904], [-83, 5848], [-125, 5798], [-176, 5818], [-234, 5824], [-285, 5812], [-340, 5872], [-380, 5889], [-396, 5911], [-402, 6006], [-415, 6060], [-395, 6099], [-428, 6101], [-440, 6119], [-468, 6117], [-513, 6130], [-575, 6172], [-601, 6179], [-652, 6229], [-650, 6265], [-679, 6255], [-723, 6259], [-732, 6306], [-757, 6337], [-728, 6361], [-722, 6415], [-744, 6474], [-779, 6502], [-809, 6505], [-811, 6545], [-852, 6574], [-888, 6576], [-927, 6607], [-951, 6606], [-974, 6636], [-949, 6654], [-903, 6660], [-896, 6639], [-839, 6647], [-817, 6663], [-855, 6720], [-832, 6755], [-843, 6776], [-833, 6809], [-846, 6834], [-838, 6882], [-821, 6899], [-824, 6932], [-894, 6987], [-935, 6997], [-957, 6969], [-994, 6997], [-999, 7060], [-967, 7085], [-983, 7110], [-991, 7150], [-973, 7197], [-939, 7193], [-913, 7217], [-919, 7270], [-872, 7321], [-840, 7324], [-805, 7314], [-732, 7351], [-705, 7343], [-713, 7368], [-699, 7387], [-667, 7362], [-640, 7355], [-580, 7383], [-561, 7377], [-556, 7337], [-563, 7300], [-519, 7293], [-455, 7310], [-448, 7285], [-420, 7295], [-378, 7337], [-371, 7360], [-339, 7386], [-335, 7404], [-288, 7417], [-232, 7399], [-209, 7384], [-136, 7387], [-100, 7373], [-37, 7419], [-32, 7440], [18, 7453], [31, 7465], [90, 7477], [155, 7499], [173, 7493], [212, 7506], [237, 7503], [260, 7528], [320, 7520], [336, 7532], [346, 7568], [343, 7663], [367, 7699], [429, 7713], [403, 7750], [444, 7764], [481, 7758], [480, 7798], [466, 7811], [485, 7840], [467, 7956], [454, 8006], [467, 8045], [468, 8082], [484, 8137], [509, 8153], [469, 8182], [429, 8185], [412, 8216], [452, 8236], [513, 8233], [567, 8243], [593, 8233], [754, 8253], [759, 8215], [781, 8199], [844, 8207], [869, 8174], [891, 8185], [909, 8246], [868, 8266], [858, 8281], [882, 8327], [910, 8364], [937, 8433], [962, 8462], [1009, 8555], [1044, 8601], [1061, 8662], [1084, 8662], [1140, 8614], [1200, 8579], [1244, 8576], [1328, 8558], [1338, 8513], [1365, 8517], [1422, 8553], [1472, 8549], [1487, 8578], [1506, 8582], [1516, 8625], [1507, 8663], [1514, 8687], [1513, 8763], [1535, 8816], [1580, 8877], [1648, 8867], [1675, 8881], [1715, 8884], [1753, 8923], [1766, 8955], [1762, 8995], [1794, 9020], [1833, 9019], [1877, 8997], [1950, 9009], [1951, 8958], [1930, 8949], [1933, 8917], [1971, 8881], [1948, 8863], [1958, 8846], [1992, 8828], [2041, 8782], [2038, 8749], [2072, 8716], [2093, 8710], [2108, 8681], [2140, 8673], [2157, 8684], [2192, 8678], [2219, 8621], [2271, 8627], [2273, 8595], [2313, 8565], [2323, 8521], [2321, 8474], [2351, 8395], [2370, 8384], [2391, 8320], [2392, 8276], [2357, 8215], [2365, 8143], [2306, 8084], [2286, 8023], [2299, 8008], [2313, 7942], [2359, 7938], [2376, 7919], [2412, 7916], [2445, 7892], [2505, 7887], [2535, 7868], [2583, 7857], [2633, 7861], [2703, 7844], [2763, 7822], [2794, 7799], [2824, 7745], [2870, 7735], [2891, 7697], [2932, 7674], [2948, 7649], [3005, 7620], [3066, 7621], [3048, 7554], [3080, 7544], [3120, 7399], [3128, 7351], [3189, 7276], [3196, 7224], [3143, 7197], [3133, 7177], [3118, 7091], [3118, 7056], [3083, 7027], [3066, 7022], [3017, 7034], [2938, 7027], [2847, 6989], [2731, 6888], [2638, 6776], [2582, 6755], [2520, 6764], [2505, 6681], [2473, 6635], [2469, 6612], [2490, 6524], [2478, 6455]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.NM',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.68,
      'hc-middle-y': 0.61,
      'hc-key': 'cn-nm',
      'hc-a2': 'NM',
      'labelrank': '2',
      'hasc': 'CN.NM',
      'alt-name': 'Nei Mongol|N猫im?ngg?',
      'woe-id': '12578009',
      'subregion': 'Western',
      'fips': 'CH20',
      'postal-code': 'NM',
      'name': '内蒙古自治区',
      'country': 'China',
      'type-en': 'Autonomous Region',
      'region': 'North China',
      'longitude': '111.623',
      'woe-name': 'Inner Mongol',
      'latitude': '41.5938',
      'woe-label': 'Nei Mongol, CN, China',
      'type': 'Z矛zh矛qu'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[3343, 7224], [3742, 7130], [3841, 7149], [4051, 7095], [4086, 7096], [4125, 7086], [4142, 7072], [4165, 7026], [4190, 7001], [4372, 6945], [4484, 6878], [4625, 6897], [4622, 6848], [4692, 6839], [4713, 6826], [4749, 6859], [4871, 6913], [5035, 6975], [5288, 7005], [5398, 6988], [5434, 6999], [5480, 6992], [5521, 6996], [5554, 7020], [5598, 7038], [5627, 7040], [5687, 7069], [5724, 7111], [5737, 7138], [5783, 7193], [5812, 7211], [5901, 7248], [5930, 7281], [5961, 7289], [5964, 7311], [5945, 7348], [5910, 7380], [5869, 7449], [5896, 7511], [5898, 7533], [5931, 7600], [5979, 7629], [6054, 7620], [6079, 7588], [6107, 7573], [6170, 7555], [6262, 7543], [6307, 7583], [6336, 7591], [6399, 7655], [6419, 7700], [6454, 7710], [6489, 7698], [6558, 7704], [6610, 7716], [6675, 7775], [6702, 7783], [6716, 7806], [6709, 7832], [6733, 7882], [6775, 7933], [6809, 7952], [6895, 7945], [6909, 8001], [6937, 8009], [6962, 7987], [7054, 8040], [7137, 8033], [7153, 8053], [7179, 8050], [7196, 8031], [7240, 8020], [7302, 8017], [7340, 8047], [7336, 8096], [7314, 8118], [7301, 8159], [7227, 8220], [7231, 8236], [7205, 8246], [7191, 8281], [7137, 8304], [7097, 8356], [7035, 8370], [6973, 8362], [6952, 8349], [6898, 8271], [6848, 8310], [6811, 8325], [6751, 8315], [6707, 8321], [6680, 8307], [6662, 8282], [6641, 8281], [6591, 8338], [6583, 8385], [6626, 8412], [6632, 8424], [6630, 8489], [6668, 8550], [6669, 8576], [6774, 8822], [6837, 8785], [6870, 8772], [6906, 8771], [6955, 8746], [7022, 8789], [7100, 8864], [7174, 8874], [7210, 8903], [7214, 8969], [7179, 8975], [7195, 8994], [7202, 9034], [7234, 9071], [7236, 9115], [7273, 9163], [7283, 9213], [7298, 9229], [7307, 9270], [7326, 9318], [7399, 9384], [7412, 9386], [7431, 9442], [7426, 9473], [7404, 9501], [7417, 9554], [7369, 9577], [7328, 9561], [7308, 9565], [7303, 9608], [7342, 9637], [7368, 9676], [7433, 9752], [7486, 9754], [7519, 9766], [7552, 9747], [7586, 9690], [7541, 9621], [7490, 9571], [7543, 9533], [7576, 9520], [7600, 9490], [7631, 9495], [7653, 9548], [7680, 9543], [7709, 9500], [7747, 9492], [7755, 9479], [7734, 9450], [7757, 9386], [7752, 9347], [7796, 9266], [7850, 9238], [7888, 9239], [7900, 9225], [7935, 9234], [7947, 9256], [7995, 9263], [8027, 9252], [8050, 9275], [8078, 9270], [8102, 9280], [8148, 9349], [8182, 9343], [8209, 9325], [8252, 9261], [8298, 9225], [8312, 9194], [8278, 9135], [8267, 9131], [8280, 9082], [8239, 9039], [8222, 8982], [8198, 8958], [8205, 8934], [8188, 8917], [8199, 8898], [8199, 8844], [8183, 8840], [8211, 8786], [8207, 8730], [8198, 8711], [8148, 8714], [8143, 8684], [8104, 8557], [8104, 8505], [8113, 8472], [8102, 8440], [8072, 8494], [8065, 8534], [8053, 8543], [8028, 8520], [7973, 8452], [7950, 8416], [7903, 8385], [7890, 8351], [7785, 8274], [7761, 8222], [7792, 8174], [7832, 8151], [7868, 8105], [7902, 8087], [7933, 8123], [7953, 8104], [7966, 8119], [7974, 8095], [7941, 8048], [7888, 8051], [7873, 8042], [7873, 7997], [7906, 7952], [7891, 7924], [7845, 7916], [7845, 7842], [7834, 7823], [7796, 7848], [7778, 7878], [7752, 7843], [7708, 7882], [7669, 7888], [7677, 7864], [7651, 7820], [7665, 7806], [7701, 7810], [7719, 7760], [7739, 7752], [7758, 7713], [7751, 7691], [7721, 7669], [7732, 7566], [7777, 7503], [7774, 7458], [7796, 7453], [7854, 7484], [7918, 7536], [7923, 7505], [7951, 7458], [7969, 7446], [7964, 7419], [8005, 7337], [8001, 7311], [7987, 7317], [7983, 7276], [8040, 7256], [8029, 7189], [7955, 7151], [7948, 7122], [7907, 7100], [7877, 7098], [7831, 7122], [7812, 7108], [7824, 7079], [7803, 7069], [7756, 7087], [7735, 7068], [7729, 7041], [7688, 7019], [7669, 7037], [7639, 7028], [7582, 6967], [7560, 6975], [7510, 6940], [7489, 6936], [7483, 6910], [7461, 6891], [7409, 6827], [7406, 6864], [7364, 6925], [7366, 6946], [7331, 6955], [7318, 6984], [7278, 6963], [7263, 6939], [7285, 6917], [7276, 6839], [7295, 6767], [7290, 6744], [7268, 6719], [7253, 6727], [7177, 6733], [7109, 6729], [7101, 6784], [7072, 6819], [7093, 6828], [7100, 6855], [7089, 6905], [7065, 6892], [7056, 6930], [7038, 6939], [7044, 6978], [7000, 7032], [6966, 7017], [6954, 7033], [6934, 6994], [6871, 6994], [6841, 6977], [6830, 6956], [6840, 6935], [6837, 6886], [6791, 6863], [6751, 6883], [6691, 6832], [6673, 6862], [6659, 6862], [6609, 6828], [6566, 6811], [6567, 6786], [6546, 6779], [6486, 6784], [6483, 6832], [6491, 6862], [6470, 6920], [6432, 6911], [6412, 6895], [6401, 6867], [6372, 6844], [6361, 6780], [6331, 6765], [6313, 6738], [6310, 6708], [6319, 6675], [6294, 6661], [6329, 6620], [6354, 6577], [6331, 6551], [6334, 6516], [6267, 6502], [6239, 6482], [6205, 6476], [6186, 6500], [6137, 6486], [6109, 6448], [6090, 6443], [6035, 6470], [6013, 6457], [5980, 6404], [5947, 6330], [5917, 6309], [5868, 6322], [5840, 6274], [5798, 6260], [5785, 6269], [5800, 6306], [5781, 6303], [5750, 6280], [5711, 6229], [5685, 6260], [5656, 6247], [5636, 6273], [5615, 6274], [5626, 6240], [5587, 6217], [5560, 6188], [5533, 6178], [5506, 6126], [5485, 6123], [5464, 6088], [5435, 6071], [5402, 6023], [5395, 5992], [5408, 5971], [5393, 5928], [5371, 5943], [5360, 5924], [5356, 5872], [5275, 5864], [5221, 5865], [5202, 5902], [5152, 5919], [5106, 5937], [5093, 5972], [5064, 5990], [5045, 5985], [5002, 5995], [4937, 6031], [4972, 6069], [4984, 6110], [5029, 6175], [5039, 6202], [5009, 6241], [5008, 6280], [4976, 6280], [4953, 6264], [4918, 6267], [4913, 6236], [4881, 6229], [4870, 6196], [4837, 6141], [4825, 6103], [4818, 6022], [4804, 6001], [4815, 5970], [4806, 5924], [4781, 5910], [4725, 5916], [4674, 5897], [4647, 5872], [4550, 5867], [4536, 5845], [4518, 5843], [4491, 5862], [4416, 5940], [4372, 5958], [4367, 6019], [4392, 6027], [4387, 6096], [4449, 6129], [4486, 6166], [4499, 6192], [4524, 6211], [4535, 6241], [4508, 6294], [4510, 6322], [4453, 6325], [4367, 6300], [4306, 6263], [4239, 6281], [4203, 6298], [4096, 6265], [4131, 6219], [4091, 6177], [4045, 6180], [3997, 6203], [3977, 6264], [3953, 6261], [3920, 6303], [3921, 6353], [3869, 6365], [3829, 6401], [3810, 6437], [3784, 6447], [3723, 6488], [3676, 6493], [3716, 6535], [3768, 6562], [3793, 6607], [3832, 6655], [3829, 6683], [3803, 6724], [3740, 6731], [3709, 6719], [3648, 6724], [3586, 6703], [3550, 6669], [3525, 6663], [3475, 6670], [3499, 6742], [3437, 6812], [3400, 6871], [3391, 6897], [3431, 6932], [3343, 7224]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.HL',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.54,
      'hc-middle-y': 0.68,
      'hc-key': 'cn-hl',
      'hc-a2': 'HL',
      'labelrank': '2',
      'hasc': 'CN.HL',
      'alt-name': 'H?il贸ngji?ng',
      'woe-id': '12577998',
      'subregion': 'Northeast',
      'fips': 'CH08',
      'postal-code': 'HL',
      'name': '黑龙江省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'Northeast China',
      'longitude': '127.97',
      'woe-name': 'Heilongjiang',
      'latitude': '46.8451',
      'woe-label': 'Heilongjiang, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[9369, 7396], [9352, 7386], [9323, 7400], [9297, 7383], [9288, 7398], [9249, 7422], [9217, 7429], [9196, 7490], [9186, 7498], [9158, 7466], [9145, 7467], [9137, 7497], [9120, 7505], [9096, 7467], [9058, 7462], [9010, 7437], [9010, 7393], [8974, 7373], [8951, 7375], [8926, 7410], [8921, 7432], [8861, 7513], [8849, 7584], [8838, 7596], [8813, 7579], [8805, 7557], [8786, 7552], [8792, 7500], [8758, 7480], [8732, 7503], [8688, 7561], [8697, 7601], [8663, 7617], [8646, 7607], [8623, 7615], [8606, 7600], [8590, 7655], [8605, 7683], [8580, 7730], [8551, 7731], [8509, 7752], [8440, 7721], [8385, 7739], [8359, 7768], [8355, 7806], [8310, 7794], [8301, 7774], [8254, 7770], [8239, 7794], [8216, 7800], [8213, 7780], [8164, 7779], [8160, 7768], [8127, 7777], [8098, 7819], [8083, 7817], [8061, 7848], [8066, 7875], [8049, 7894], [8059, 7911], [8041, 7978], [8008, 7968], [7906, 7952], [7873, 7997], [7873, 8042], [7888, 8051], [7941, 8048], [7974, 8095], [7966, 8119], [7953, 8104], [7933, 8123], [7902, 8087], [7868, 8105], [7832, 8151], [7792, 8174], [7761, 8222], [7785, 8274], [7890, 8351], [7903, 8385], [7950, 8416], [7973, 8452], [8028, 8520], [8053, 8543], [8065, 8534], [8072, 8494], [8102, 8440], [8113, 8472], [8104, 8505], [8104, 8557], [8143, 8684], [8148, 8714], [8198, 8711], [8207, 8730], [8211, 8786], [8183, 8840], [8199, 8844], [8199, 8898], [8188, 8917], [8205, 8934], [8198, 8958], [8222, 8982], [8239, 9039], [8280, 9082], [8267, 9131], [8278, 9135], [8312, 9194], [8298, 9225], [8252, 9261], [8209, 9325], [8182, 9343], [8148, 9349], [8102, 9280], [8078, 9270], [8050, 9275], [8027, 9252], [7995, 9263], [7947, 9256], [7935, 9234], [7900, 9225], [7888, 9239], [7850, 9238], [7796, 9266], [7752, 9347], [7757, 9386], [7734, 9450], [7755, 9479], [7747, 9492], [7709, 9500], [7680, 9543], [7653, 9548], [7631, 9495], [7600, 9490], [7576, 9520], [7543, 9533], [7490, 9571], [7541, 9621], [7586, 9690], [7552, 9747], [7519, 9766], [7594, 9800], [7625, 9801], [7666, 9820], [7687, 9814], [7750, 9820], [7796, 9833], [7811, 9849], [7859, 9837], [7869, 9851], [7889, 9836], [7928, 9825], [7954, 9799], [7972, 9808], [8002, 9771], [8047, 9764], [8083, 9745], [8080, 9759], [8119, 9771], [8185, 9732], [8201, 9738], [8221, 9718], [8212, 9689], [8239, 9699], [8264, 9663], [8278, 9669], [8281, 9641], [8266, 9627], [8307, 9604], [8331, 9568], [8328, 9548], [8349, 9539], [8331, 9517], [8366, 9507], [8356, 9461], [8394, 9401], [8405, 9397], [8402, 9361], [8424, 9348], [8426, 9318], [8443, 9315], [8430, 9284], [8458, 9292], [8449, 9271], [8455, 9227], [8493, 9188], [8520, 9150], [8537, 9101], [8526, 9076], [8536, 9041], [8579, 9017], [8569, 8966], [8577, 8914], [8600, 8901], [8616, 8872], [8635, 8860], [8662, 8863], [8680, 8850], [8728, 8864], [8797, 8869], [8791, 8845], [8836, 8836], [8850, 8817], [8867, 8828], [8896, 8821], [8901, 8842], [8918, 8838], [8933, 8806], [8956, 8807], [8996, 8750], [9057, 8712], [9079, 8722], [9128, 8721], [9110, 8659], [9132, 8620], [9149, 8627], [9167, 8587], [9151, 8513], [9193, 8476], [9203, 8435], [9218, 8427], [9283, 8449], [9312, 8434], [9411, 8450], [9438, 8465], [9471, 8462], [9489, 8505], [9490, 8526], [9515, 8527], [9555, 8573], [9570, 8580], [9618, 8577], [9634, 8584], [9657, 8621], [9711, 8649], [9764, 8669], [9791, 8667], [9821, 8646], [9822, 8614], [9806, 8588], [9851, 8510], [9840, 8477], [9811, 8433], [9780, 8424], [9761, 8383], [9778, 8350], [9762, 8336], [9752, 8275], [9753, 8222], [9733, 8184], [9750, 8158], [9749, 8130], [9716, 8097], [9723, 8082], [9717, 8045], [9694, 8028], [9697, 7977], [9688, 7953], [9652, 7931], [9643, 7912], [9641, 7864], [9648, 7835], [9623, 7807], [9602, 7813], [9576, 7858], [9522, 7873], [9483, 7868], [9451, 7838], [9418, 7860], [9405, 7829], [9389, 7823], [9388, 7796], [9359, 7761], [9296, 7742], [9278, 7723], [9305, 7687], [9356, 7538], [9349, 7528], [9347, 7470], [9353, 7407], [9369, 7396]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.SC',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.47,
      'hc-middle-y': 0.48,
      'hc-key': 'cn-sc',
      'hc-a2': 'SC',
      'labelrank': '2',
      'hasc': 'CN.SC',
      'alt-name': 'S矛chu?n',
      'woe-id': '12578016',
      'subregion': 'Western',
      'fips': 'CH32',
      'postal-code': 'SC',
      'name': '四川省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'Southwest China',
      'longitude': '102.384',
      'woe-name': 'Sichuan',
      'latitude': '30.5431',
      'woe-label': 'Sichuan, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[4590, 3632], [4578, 3663], [4591, 3695], [4547, 3717], [4528, 3709], [4513, 3677], [4454, 3668], [4410, 3696], [4403, 3716], [4425, 3727], [4414, 3768], [4393, 3781], [4392, 3826], [4431, 3840], [4426, 3848], [4335, 3848], [4315, 3861], [4302, 3831], [4316, 3784], [4281, 3762], [4269, 3775], [4230, 3747], [4236, 3686], [4174, 3623], [4152, 3590], [4123, 3586], [4104, 3566], [4100, 3484], [4114, 3462], [4126, 3395], [4102, 3354], [4087, 3359], [4043, 3331], [4025, 3367], [3959, 3338], [3929, 3308], [3890, 3314], [3875, 3301], [3860, 3333], [3827, 3343], [3839, 3374], [3821, 3408], [3796, 3427], [3815, 3456], [3798, 3462], [3788, 3495], [3750, 3537], [3759, 3569], [3726, 3573], [3726, 3603], [3704, 3642], [3706, 3657], [3670, 3730], [3619, 3724], [3606, 3707], [3554, 3783], [3554, 3810], [3578, 3819], [3576, 3843], [3522, 3907], [3503, 3941], [3502, 3963], [3484, 3958], [3454, 3908], [3432, 3902], [3422, 3822], [3384, 3882], [3389, 3919], [3381, 3944], [3390, 4059], [3383, 4079], [3384, 4136], [3375, 4157], [3394, 4215], [3385, 4268], [3387, 4340], [3381, 4386], [3392, 4404], [3360, 4442], [3368, 4462], [3333, 4506], [3343, 4537], [3366, 4517], [3391, 4542], [3340, 4603], [3313, 4655], [3322, 4693], [3283, 4758], [3282, 4781], [3248, 4810], [3193, 4833], [3142, 4874], [3133, 4920], [3163, 4947], [3167, 4985], [3214, 5029], [3180, 5043], [3156, 5082], [3160, 5141], [3205, 5150], [3223, 5166], [3229, 5133], [3286, 5149], [3319, 5141], [3334, 5118], [3364, 5113], [3396, 5073], [3391, 5059], [3409, 5029], [3412, 4985], [3424, 4955], [3492, 4908], [3502, 4882], [3543, 4866], [3577, 4842], [3594, 4881], [3614, 4904], [3648, 4880], [3666, 4843], [3656, 4818], [3676, 4809], [3683, 4829], [3712, 4834], [3739, 4787], [3721, 4771], [3730, 4751], [3745, 4761], [3763, 4812], [3806, 4797], [3858, 4806], [3873, 4843], [3855, 4863], [3865, 4906], [3921, 4926], [3957, 4898], [3975, 4929], [3964, 4942], [3990, 4988], [4010, 4990], [4015, 4958], [3995, 4928], [3997, 4894], [4083, 4946], [4123, 4963], [4124, 4980], [4101, 4998], [4101, 5024], [4072, 5076], [4110, 5081], [4125, 5099], [4159, 5102], [4152, 5116], [4193, 5144], [4222, 5147], [4256, 5115], [4263, 5035], [4278, 5021], [4334, 5027], [4325, 5006], [4367, 4995], [4433, 4989], [4447, 4947], [4484, 4907], [4464, 4896], [4485, 4847], [4459, 4800], [4481, 4789], [4509, 4760], [4573, 4739], [4610, 4734], [4645, 4742], [4679, 4764], [4670, 4793], [4692, 4800], [4704, 4759], [4750, 4762], [4764, 4782], [4808, 4783], [4797, 4750], [4829, 4721], [4902, 4736], [4924, 4750], [4991, 4740], [4990, 4698], [5015, 4681], [5063, 4695], [5064, 4669], [5103, 4663], [5137, 4625], [5167, 4606], [5177, 4623], [5213, 4630], [5260, 4625], [5267, 4613], [5236, 4607], [5247, 4591], [5217, 4564], [5220, 4552], [5260, 4521], [5263, 4502], [5240, 4470], [5204, 4449], [5197, 4419], [5165, 4395], [5158, 4354], [5142, 4317], [5118, 4301], [5101, 4322], [5059, 4309], [5048, 4295], [5051, 4261], [5030, 4237], [4999, 4179], [4959, 4140], [4897, 4143], [4880, 4191], [4865, 4208], [4805, 4184], [4784, 4213], [4720, 4234], [4707, 4204], [4671, 4174], [4705, 4147], [4697, 4110], [4667, 4097], [4664, 4082], [4637, 4076], [4612, 4050], [4615, 4024], [4633, 3995], [4688, 3965], [4694, 3913], [4719, 3895], [4746, 3906], [4794, 3880], [4800, 3835], [4815, 3812], [4806, 3792], [4739, 3856], [4719, 3825], [4677, 3821], [4663, 3799], [4668, 3767], [4710, 3747], [4713, 3723], [4757, 3725], [4793, 3684], [4800, 3647], [4780, 3634], [4751, 3639], [4656, 3620], [4627, 3644], [4590, 3632]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.GZ',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.55,
      'hc-middle-y': 0.58,
      'hc-key': 'cn-gz',
      'hc-a2': 'GZ',
      'labelrank': '2',
      'hasc': 'CN.GZ',
      'alt-name': 'G霉izh?u',
      'woe-id': '12578007',
      'subregion': 'Western',
      'fips': 'CH18',
      'postal-code': 'GZ',
      'name': '贵州省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'Southwest China',
      'longitude': '106.559',
      'woe-name': 'Guizhou',
      'latitude': '26.8033',
      'woe-label': 'Guizhou, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[4400, 2976], [4402, 2992], [4436, 3031], [4442, 3078], [4455, 3089], [4413, 3118], [4409, 3146], [4365, 3184], [4390, 3226], [4386, 3246], [4409, 3263], [4421, 3316], [4449, 3339], [4428, 3386], [4410, 3394], [4404, 3416], [4389, 3403], [4347, 3406], [4319, 3377], [4273, 3394], [4265, 3457], [4276, 3479], [4262, 3501], [4242, 3508], [4309, 3574], [4323, 3576], [4360, 3544], [4396, 3580], [4415, 3558], [4445, 3549], [4500, 3545], [4543, 3565], [4566, 3561], [4590, 3632], [4627, 3644], [4656, 3620], [4751, 3639], [4780, 3634], [4800, 3647], [4793, 3684], [4757, 3725], [4713, 3723], [4710, 3747], [4668, 3767], [4663, 3799], [4677, 3821], [4719, 3825], [4739, 3856], [4806, 3792], [4815, 3812], [4836, 3804], [4844, 3833], [4834, 3867], [4853, 3854], [4864, 3824], [4850, 3802], [4876, 3789], [4909, 3827], [4910, 3853], [4932, 3856], [4947, 3877], [4973, 3874], [4989, 3857], [5027, 3871], [5041, 3897], [5026, 3916], [5042, 3954], [5054, 3940], [5098, 3927], [5098, 3905], [5115, 3892], [5151, 3908], [5197, 3910], [5210, 3842], [5202, 3822], [5252, 3801], [5250, 3750], [5269, 3741], [5262, 3768], [5290, 3760], [5278, 3719], [5351, 3708], [5364, 3760], [5385, 3775], [5385, 3734], [5402, 3720], [5390, 3673], [5400, 3607], [5417, 3582], [5411, 3562], [5382, 3535], [5368, 3537], [5282, 3459], [5313, 3445], [5343, 3468], [5355, 3456], [5370, 3472], [5412, 3466], [5425, 3431], [5412, 3414], [5427, 3404], [5380, 3376], [5401, 3333], [5378, 3283], [5399, 3273], [5409, 3221], [5397, 3213], [5375, 3156], [5352, 3170], [5305, 3166], [5294, 3139], [5320, 3153], [5321, 3113], [5267, 3110], [5252, 3128], [5225, 3088], [5170, 3117], [5136, 3084], [5134, 3058], [5079, 3033], [5042, 3048], [5037, 3070], [5006, 3051], [4989, 3087], [4958, 3130], [4924, 3125], [4902, 3106], [4904, 3064], [4882, 3052], [4837, 3049], [4820, 3034], [4762, 3010], [4731, 3007], [4733, 2967], [4700, 2937], [4680, 2957], [4653, 2956], [4631, 2973], [4598, 2981], [4586, 3006], [4555, 3010], [4535, 3028], [4505, 3004], [4497, 2982], [4468, 2975], [4437, 2949], [4400, 2976]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.GX',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.56,
      'hc-middle-y': 0.49,
      'hc-key': 'cn-gx',
      'hc-a2': 'GX',
      'labelrank': '2',
      'hasc': 'CN.GX',
      'alt-name': 'Guangxi Zhuang|Guangxi Zhu脿ngz煤',
      'woe-id': '12578006',
      'subregion': 'Western',
      'fips': 'CH16',
      'postal-code': 'GX',
      'name': '广西壮族自治区',
      'country': 'China',
      'type-en': 'Autonomous Region',
      'region': 'South Central China',
      'longitude': '108.756',
      'woe-name': 'Guangxi',
      'latitude': '23.7451',
      'woe-label': 'Guangxi, CN, China',
      'type': 'Z矛zh矛qu'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[4581, 2613], [4652, 2689], [4679, 2676], [4710, 2691], [4727, 2763], [4720, 2787], [4694, 2819], [4645, 2801], [4592, 2825], [4576, 2808], [4521, 2840], [4524, 2872], [4512, 2895], [4439, 2912], [4433, 2889], [4407, 2899], [4390, 2940], [4400, 2976], [4437, 2949], [4468, 2975], [4497, 2982], [4505, 3004], [4535, 3028], [4555, 3010], [4586, 3006], [4598, 2981], [4631, 2973], [4653, 2956], [4680, 2957], [4700, 2937], [4733, 2967], [4731, 3007], [4762, 3010], [4820, 3034], [4837, 3049], [4882, 3052], [4904, 3064], [4902, 3106], [4924, 3125], [4958, 3130], [4989, 3087], [5006, 3051], [5037, 3070], [5042, 3048], [5079, 3033], [5134, 3058], [5136, 3084], [5170, 3117], [5225, 3088], [5252, 3128], [5267, 3110], [5321, 3113], [5320, 3153], [5294, 3139], [5305, 3166], [5352, 3170], [5375, 3156], [5397, 3213], [5409, 3221], [5438, 3224], [5452, 3187], [5472, 3190], [5505, 3254], [5531, 3243], [5525, 3218], [5546, 3221], [5568, 3204], [5588, 3233], [5628, 3257], [5632, 3283], [5666, 3268], [5697, 3267], [5711, 3293], [5772, 3267], [5759, 3195], [5776, 3173], [5810, 3187], [5780, 3124], [5782, 3093], [5751, 3063], [5740, 3035], [5715, 3016], [5707, 2988], [5722, 2964], [5742, 2991], [5772, 3014], [5803, 3004], [5811, 2934], [5802, 2909], [5820, 2900], [5851, 2931], [5903, 2929], [5918, 2920], [5904, 2890], [5919, 2879], [5927, 2841], [5912, 2818], [5890, 2808], [5896, 2756], [5870, 2719], [5846, 2721], [5834, 2681], [5807, 2671], [5790, 2631], [5784, 2566], [5793, 2551], [5780, 2515], [5744, 2480], [5720, 2478], [5711, 2456], [5655, 2444], [5640, 2423], [5658, 2378], [5636, 2375], [5630, 2356], [5593, 2350], [5566, 2359], [5574, 2295], [5488, 2289], [5477, 2249], [5441, 2225], [5439, 2203], [5412, 2226], [5405, 2267], [5389, 2254], [5405, 2227], [5395, 2208], [5313, 2190], [5293, 2201], [5315, 2214], [5314, 2235], [5279, 2237], [5256, 2255], [5234, 2248], [5198, 2285], [5212, 2301], [5173, 2298], [5184, 2280], [5185, 2237], [5165, 2229], [5163, 2253], [5145, 2264], [5136, 2228], [5122, 2247], [5114, 2225], [5091, 2233], [5080, 2213], [5025, 2257], [4997, 2247], [4942, 2247], [4927, 2275], [4907, 2275], [4869, 2305], [4875, 2323], [4801, 2342], [4806, 2392], [4780, 2439], [4790, 2471], [4813, 2471], [4828, 2507], [4813, 2536], [4777, 2550], [4741, 2536], [4718, 2558], [4677, 2566], [4646, 2552], [4614, 2585], [4586, 2590], [4581, 2613]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.LN',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.63,
      'hc-middle-y': 0.44,
      'hc-key': 'cn-ln',
      'hc-a2': 'LN',
      'labelrank': '2',
      'hasc': 'CN.LN',
      'alt-name': 'Li谩on铆ng',
      'woe-id': '12578008',
      'subregion': 'Northeast',
      'fips': 'CH19',
      'postal-code': 'LN',
      'name': '辽宁省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'Northeast China',
      'longitude': '123.07',
      'woe-name': 'Liaoning',
      'latitude': '41.386',
      'woe-label': 'Liaoning, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7268, 6719], [7290, 6744], [7295, 6767], [7276, 6839], [7285, 6917], [7263, 6939], [7278, 6963], [7318, 6984], [7331, 6955], [7366, 6946], [7364, 6925], [7406, 6864], [7409, 6827], [7461, 6891], [7483, 6910], [7489, 6936], [7510, 6940], [7560, 6975], [7582, 6967], [7639, 7028], [7669, 7037], [7688, 7019], [7729, 7041], [7735, 7068], [7756, 7087], [7803, 7069], [7824, 7079], [7812, 7108], [7831, 7122], [7877, 7098], [7907, 7100], [7948, 7122], [7955, 7151], [8029, 7189], [8040, 7256], [8048, 7285], [8096, 7248], [8146, 7231], [8172, 7198], [8165, 7181], [8187, 7143], [8212, 7170], [8233, 7208], [8255, 7205], [8253, 7156], [8278, 7119], [8275, 7101], [8300, 7084], [8303, 7064], [8323, 7045], [8349, 6988], [8376, 6987], [8346, 6938], [8353, 6872], [8379, 6874], [8384, 6849], [8421, 6783], [8438, 6774], [8445, 6749], [8434, 6716], [8415, 6693], [8439, 6682], [8436, 6660], [8414, 6661], [8390, 6624], [8362, 6618], [8321, 6596], [8323, 6578], [8299, 6583], [8269, 6539], [8256, 6535], [8208, 6483], [8197, 6444], [8168, 6420], [8144, 6413], [8096, 6414], [8078, 6431], [8073, 6402], [8041, 6389], [8036, 6401], [8004, 6386], [7999, 6370], [7968, 6371], [7961, 6355], [7940, 6355], [7894, 6317], [7860, 6302], [7811, 6250], [7814, 6236], [7768, 6187], [7751, 6205], [7718, 6186], [7740, 6169], [7700, 6152], [7675, 6152], [7640, 6130], [7632, 6181], [7671, 6188], [7732, 6219], [7716, 6243], [7748, 6287], [7706, 6283], [7689, 6308], [7679, 6283], [7659, 6287], [7662, 6315], [7645, 6319], [7659, 6336], [7702, 6356], [7685, 6373], [7698, 6400], [7758, 6434], [7777, 6481], [7829, 6559], [7798, 6586], [7781, 6614], [7744, 6633], [7738, 6660], [7724, 6636], [7694, 6633], [7654, 6654], [7621, 6649], [7560, 6587], [7556, 6569], [7513, 6520], [7507, 6484], [7495, 6470], [7408, 6434], [7390, 6417], [7369, 6443], [7369, 6468], [7349, 6468], [7333, 6546], [7285, 6542], [7265, 6563], [7265, 6582], [7242, 6570], [7203, 6609], [7217, 6657], [7256, 6695], [7268, 6719]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.JS',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.53,
      'hc-middle-y': 0.39,
      'hc-key': 'cn-js',
      'hc-a2': 'JS',
      'labelrank': '2',
      'hasc': 'CN.JS',
      'alt-name': 'Ji?ngs?',
      'woe-id': '12577994',
      'subregion': null,
      'fips': 'CH04',
      'postal-code': 'JS',
      'name': '江苏省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'East China',
      'longitude': '119.942',
      'woe-name': 'Jiangsu',
      'latitude': '32.9844',
      'woe-label': 'Jiangsu, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[7324, 5269], [7308, 5251], [7310, 5187], [7339, 5202], [7362, 5196], [7361, 5181], [7397, 5151], [7454, 5132], [7516, 5101], [7540, 5038], [7548, 4998], [7567, 4975], [7565, 4951], [7594, 4913], [7602, 4881], [7620, 4866], [7638, 4811], [7650, 4809], [7654, 4771], [7647, 4731], [7698, 4696], [7751, 4670], [7749, 4637], [7765, 4609], [7806, 4600], [7840, 4576], [7861, 4532], [7842, 4517], [7814, 4523], [7737, 4557], [7704, 4534], [7678, 4537], [7643, 4583], [7581, 4594], [7539, 4562], [7513, 4560], [7485, 4575], [7449, 4642], [7467, 4590], [7488, 4560], [7532, 4553], [7575, 4571], [7575, 4580], [7632, 4573], [7648, 4539], [7633, 4533], [7711, 4509], [7751, 4467], [7722, 4458], [7701, 4388], [7662, 4383], [7672, 4355], [7630, 4345], [7634, 4326], [7593, 4296], [7583, 4324], [7566, 4334], [7521, 4333], [7483, 4364], [7481, 4379], [7443, 4383], [7422, 4373], [7370, 4384], [7366, 4405], [7330, 4405], [7313, 4393], [7263, 4389], [7250, 4418], [7274, 4456], [7269, 4480], [7231, 4485], [7234, 4495], [7193, 4514], [7194, 4530], [7168, 4549], [7174, 4574], [7198, 4608], [7224, 4617], [7226, 4666], [7203, 4693], [7243, 4703], [7268, 4700], [7306, 4667], [7328, 4701], [7318, 4752], [7285, 4784], [7259, 4785], [7234, 4730], [7173, 4728], [7153, 4738], [7141, 4771], [7135, 4829], [7109, 4822], [7080, 4840], [7104, 4899], [7113, 4897], [7124, 4946], [7113, 4963], [7038, 4952], [7041, 4987], [7017, 5016], [6994, 5025], [6928, 5033], [6904, 5047], [6887, 5100], [6859, 5102], [6777, 5156], [6794, 5216], [6861, 5230], [6883, 5213], [6906, 5174], [6930, 5115], [6959, 5147], [6985, 5122], [7042, 5135], [7045, 5164], [7094, 5165], [7114, 5142], [7118, 5108], [7160, 5119], [7175, 5176], [7214, 5176], [7228, 5191], [7246, 5258], [7286, 5262], [7304, 5276], [7324, 5269]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.GS',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.24,
      'hc-middle-y': 0.23,
      'hc-key': 'cn-gs',
      'hc-a2': 'GS',
      'labelrank': '2',
      'hasc': 'CN.GS',
      'alt-name': 'G?ns霉',
      'woe-id': '12578005',
      'subregion': 'Western',
      'fips': 'CH15',
      'postal-code': 'GS',
      'name': '甘肃省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'Northwest China',
      'longitude': '100.735',
      'woe-name': 'Gansu',
      'latitude': '38.7393',
      'woe-label': 'Gansu, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[3990, 4988], [3958, 4986], [3939, 5032], [3910, 5019], [3874, 5028], [3872, 5071], [3839, 5091], [3813, 5145], [3820, 5177], [3845, 5196], [3863, 5184], [3970, 5141], [3999, 5110], [4029, 5123], [4086, 5169], [4077, 5203], [4042, 5220], [4035, 5244], [4012, 5239], [4006, 5256], [4039, 5273], [4058, 5307], [4109, 5330], [4132, 5362], [4112, 5381], [4119, 5410], [4145, 5415], [4167, 5436], [4195, 5429], [4203, 5453], [4203, 5504], [4255, 5499], [4262, 5535], [4251, 5558], [4273, 5586], [4233, 5615], [4227, 5655], [4200, 5694], [4214, 5726], [4177, 5765], [4197, 5812], [4176, 5840], [4106, 5892], [4114, 5908], [4093, 5952], [4061, 5905], [3975, 5977], [3934, 6019], [3860, 6058], [3848, 6094], [3813, 6110], [3777, 6155], [3764, 6134], [3774, 6090], [3747, 6117], [3712, 6132], [3670, 6171], [3661, 6192], [3594, 6266], [3595, 6282], [3540, 6314], [3505, 6289], [3476, 6294], [3456, 6311], [3411, 6266], [3341, 6313], [3284, 6359], [3223, 6376], [3209, 6355], [3212, 6330], [3188, 6182], [3169, 6183], [3111, 6217], [3111, 6235], [3079, 6257], [3033, 6275], [3026, 6293], [2977, 6327], [2953, 6363], [2934, 6373], [2910, 6408], [2864, 6405], [2764, 6458], [2698, 6467], [2659, 6463], [2626, 6472], [2585, 6469], [2541, 6455], [2478, 6455], [2490, 6524], [2469, 6612], [2473, 6635], [2505, 6681], [2520, 6764], [2582, 6755], [2638, 6776], [2731, 6888], [2847, 6989], [2938, 7027], [3017, 7034], [3066, 7022], [3083, 7027], [3118, 7056], [3118, 7091], [3133, 7177], [3143, 7197], [3196, 7224], [3215, 7224], [3343, 7224], [3431, 6932], [3391, 6897], [3400, 6871], [3437, 6812], [3499, 6742], [3475, 6670], [3525, 6663], [3550, 6669], [3586, 6703], [3648, 6724], [3709, 6719], [3740, 6731], [3803, 6724], [3829, 6683], [3832, 6655], [3793, 6607], [3768, 6562], [3716, 6535], [3676, 6493], [3723, 6488], [3784, 6447], [3810, 6437], [3829, 6401], [3869, 6365], [3921, 6353], [3920, 6303], [3953, 6261], [3977, 6264], [3997, 6203], [4045, 6180], [4091, 6177], [4131, 6219], [4096, 6265], [4203, 6298], [4239, 6281], [4306, 6263], [4367, 6300], [4453, 6325], [4510, 6322], [4508, 6294], [4535, 6241], [4524, 6211], [4499, 6192], [4486, 6166], [4449, 6129], [4387, 6096], [4392, 6027], [4367, 6019], [4372, 5958], [4416, 5940], [4491, 5862], [4518, 5843], [4536, 5845], [4556, 5853], [4598, 5844], [4603, 5827], [4583, 5807], [4626, 5797], [4637, 5768], [4683, 5736], [4707, 5691], [4687, 5671], [4694, 5638], [4723, 5568], [4720, 5534], [4703, 5523], [4696, 5495], [4715, 5453], [4762, 5433], [4786, 5388], [4807, 5395], [4829, 5379], [4800, 5367], [4857, 5362], [4875, 5333], [4904, 5345], [4914, 5396], [4901, 5430], [4933, 5435], [4957, 5422], [4993, 5447], [4981, 5469], [5002, 5513], [4979, 5545], [4940, 5562], [4920, 5561], [4926, 5662], [4945, 5666], [4955, 5691], [4942, 5714], [4954, 5729], [4958, 5771], [4985, 5772], [5011, 5752], [5058, 5752], [5076, 5740], [5074, 5704], [5150, 5680], [5185, 5663], [5212, 5625], [5271, 5611], [5286, 5591], [5317, 5583], [5334, 5565], [5323, 5535], [5332, 5511], [5327, 5484], [5291, 5456], [5293, 5415], [5309, 5379], [5311, 5343], [5286, 5316], [5223, 5322], [5186, 5308], [5145, 5332], [5131, 5311], [5158, 5253], [5109, 5252], [5095, 5243], [5062, 5248], [5041, 5238], [5012, 5273], [4987, 5286], [4920, 5286], [4906, 5276], [4915, 5237], [4903, 5209], [4868, 5175], [4877, 5160], [4902, 5159], [4934, 5126], [4929, 5096], [4910, 5103], [4915, 5070], [4900, 5064], [4881, 5017], [4890, 4971], [4903, 4947], [4891, 4935], [4872, 4953], [4829, 4942], [4811, 4956], [4763, 4931], [4740, 4907], [4745, 4885], [4776, 4870], [4768, 4812], [4719, 4793], [4692, 4800], [4670, 4793], [4679, 4764], [4645, 4742], [4610, 4734], [4573, 4739], [4509, 4760], [4481, 4789], [4459, 4800], [4485, 4847], [4464, 4896], [4484, 4907], [4447, 4947], [4433, 4989], [4367, 4995], [4325, 5006], [4334, 5027], [4278, 5021], [4263, 5035], [4256, 5115], [4222, 5147], [4193, 5144], [4152, 5116], [4159, 5102], [4125, 5099], [4110, 5081], [4072, 5076], [4101, 5024], [4101, 4998], [4124, 4980], [4123, 4963], [4083, 4946], [3997, 4894], [3995, 4928], [4015, 4958], [4010, 4990], [3990, 4988]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.SX',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.50,
      'hc-middle-y': 0.44,
      'hc-key': 'cn-sx',
      'hc-a2': 'SX',
      'labelrank': '2',
      'hasc': 'CN.SX',
      'alt-name': 'Sh?nx?',
      'woe-id': '12578013',
      'subregion': 'Central',
      'fips': 'CH24',
      'postal-code': 'SX',
      'name': '山西省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'North China',
      'longitude': '112.389',
      'woe-name': 'Shanxi',
      'latitude': '37.7586',
      'woe-label': 'Shanxi, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[5631, 5155], [5615, 5166], [5618, 5231], [5634, 5289], [5689, 5380], [5679, 5438], [5670, 5447], [5660, 5506], [5669, 5610], [5652, 5631], [5661, 5641], [5649, 5680], [5680, 5738], [5706, 5770], [5700, 5796], [5730, 5834], [5723, 5882], [5681, 5927], [5682, 5985], [5746, 6043], [5750, 6082], [5771, 6127], [5775, 6171], [5798, 6185], [5818, 6242], [5798, 6260], [5840, 6274], [5868, 6322], [5917, 6309], [5947, 6330], [5980, 6404], [6013, 6457], [6035, 6470], [6090, 6443], [6109, 6448], [6137, 6486], [6186, 6500], [6205, 6476], [6239, 6482], [6267, 6502], [6334, 6516], [6331, 6551], [6354, 6577], [6373, 6531], [6378, 6490], [6419, 6478], [6341, 6444], [6314, 6404], [6342, 6381], [6396, 6368], [6399, 6320], [6425, 6290], [6403, 6236], [6398, 6205], [6366, 6181], [6328, 6193], [6299, 6182], [6282, 6144], [6294, 6120], [6240, 6056], [6241, 5990], [6287, 5966], [6331, 5872], [6345, 5860], [6336, 5814], [6280, 5724], [6284, 5672], [6266, 5668], [6253, 5644], [6224, 5637], [6239, 5578], [6274, 5548], [6265, 5517], [6267, 5479], [6250, 5422], [6252, 5384], [6219, 5348], [6141, 5312], [6119, 5291], [6077, 5308], [6047, 5287], [5959, 5292], [5955, 5248], [5915, 5257], [5887, 5240], [5863, 5207], [5778, 5187], [5735, 5164], [5667, 5147], [5631, 5155]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.HE',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.51,
      'hc-middle-y': 0.46,
      'hc-key': 'cn-he',
      'hc-a2': 'HE',
      'labelrank': '2',
      'hasc': 'CN.HE',
      'alt-name': 'H茅n谩n',
      'woe-id': '12577999',
      'subregion': 'Central',
      'fips': 'CH09',
      'postal-code': 'HE',
      'name': '河南省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'South Central China',
      'longitude': '113.484',
      'woe-name': 'Henan',
      'latitude': '33.9055',
      'woe-label': 'Henan, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[5631, 5155], [5667, 5147], [5735, 5164], [5778, 5187], [5863, 5207], [5887, 5240], [5915, 5257], [5955, 5248], [5959, 5292], [6047, 5287], [6077, 5308], [6119, 5291], [6141, 5312], [6219, 5348], [6252, 5384], [6250, 5422], [6267, 5479], [6265, 5517], [6274, 5548], [6324, 5549], [6355, 5523], [6390, 5523], [6429, 5498], [6493, 5494], [6509, 5481], [6533, 5509], [6559, 5504], [6569, 5487], [6600, 5504], [6593, 5466], [6577, 5451], [6576, 5415], [6598, 5444], [6688, 5473], [6716, 5492], [6708, 5460], [6676, 5451], [6630, 5405], [6607, 5393], [6557, 5332], [6527, 5324], [6504, 5286], [6487, 5277], [6484, 5239], [6515, 5238], [6548, 5223], [6556, 5198], [6597, 5186], [6598, 5162], [6619, 5140], [6671, 5139], [6722, 5150], [6734, 5139], [6736, 5111], [6783, 5072], [6811, 5075], [6810, 5037], [6830, 4999], [6793, 4974], [6788, 4962], [6743, 4944], [6702, 4986], [6700, 5008], [6656, 5023], [6641, 5019], [6624, 4984], [6637, 4971], [6626, 4950], [6639, 4914], [6583, 4893], [6584, 4836], [6573, 4812], [6545, 4797], [6512, 4806], [6496, 4797], [6504, 4768], [6554, 4746], [6557, 4685], [6589, 4678], [6628, 4643], [6653, 4663], [6687, 4673], [6699, 4558], [6694, 4505], [6648, 4503], [6623, 4492], [6596, 4440], [6593, 4419], [6563, 4425], [6562, 4448], [6545, 4459], [6520, 4432], [6475, 4435], [6432, 4453], [6434, 4491], [6396, 4490], [6354, 4515], [6320, 4492], [6286, 4544], [6278, 4581], [6284, 4632], [6274, 4645], [6235, 4617], [6198, 4622], [6175, 4644], [6142, 4647], [6085, 4630], [6043, 4637], [5995, 4631], [5950, 4656], [5898, 4671], [5885, 4690], [5850, 4693], [5846, 4709], [5790, 4766], [5771, 4816], [5746, 4844], [5754, 4868], [5746, 4920], [5713, 4945], [5705, 4967], [5676, 4985], [5686, 5008], [5682, 5050], [5647, 5073], [5656, 5088], [5628, 5124], [5631, 5155]]]
    }
  }, {
    'type': 'Feature',
    'id': 'CN.JX',
    'properties': {
      'hc-group': 'admin1',
      'hc-middle-x': 0.36,
      'hc-middle-y': 0.48,
      'hc-key': 'cn-jx',
      'hc-a2': 'JX',
      'labelrank': '2',
      'hasc': 'CN.JX',
      'alt-name': 'Ji?ngx?',
      'woe-id': '12577993',
      'subregion': 'Central',
      'fips': 'CH03',
      'postal-code': 'JX',
      'name': '江西省',
      'country': 'China',
      'type-en': 'Province',
      'region': 'East China',
      'longitude': '116.017',
      'woe-name': 'Jiangxi',
      'latitude': '27.6397',
      'woe-label': 'Jiangxi, CN, China',
      'type': 'Sh?ng'
    },
    'geometry': {
      'type': 'Polygon',
      'coordinates': [[[6311, 3076], [6322, 3106], [6307, 3144], [6330, 3185], [6334, 3215], [6369, 3238], [6359, 3249], [6311, 3238], [6340, 3301], [6343, 3329], [6299, 3346], [6292, 3385], [6304, 3411], [6277, 3455], [6296, 3501], [6259, 3497], [6246, 3506], [6238, 3556], [6266, 3607], [6273, 3643], [6309, 3652], [6329, 3671], [6344, 3705], [6363, 3713], [6371, 3739], [6361, 3761], [6337, 3774], [6348, 3786], [6354, 3824], [6307, 3862], [6307, 3887], [6338, 3918], [6375, 3928], [6383, 3953], [6419, 3944], [6487, 3961], [6500, 3991], [6550, 4005], [6540, 4021], [6576, 4011], [6605, 4034], [6618, 4068], [6661, 4068], [6691, 4040], [6748, 4053], [6766, 4051], [6795, 4073], [6816, 4075], [6846, 4113], [6874, 4107], [6893, 4084], [6876, 4047], [6852, 4036], [6847, 4018], [6863, 4001], [6895, 4003], [6932, 4038], [6929, 4067], [6953, 4087], [6960, 4069], [6995, 4066], [6995, 4053], [7020, 4020], [7056, 4006], [7111, 4011], [7136, 3999], [7149, 3975], [7141, 3950], [7126, 3944], [7116, 3914], [7129, 3894], [7162, 3873], [7203, 3816], [7215, 3734], [7210, 3724], [7191, 3708], [7195, 3682], [7148, 3667], [7135, 3653], [7088, 3642], [7073, 3614], [7045, 3625], [7025, 3648], [6981, 3622], [6982, 3603], [6948, 3556], [6946, 3507], [6957, 3491], [6935, 3454], [6912, 3433], [6861, 3425], [6837, 3398], [6829, 3358], [6853, 3314], [6809, 3267], [6814, 3237], [6795, 3193], [6758, 3173], [6763, 3153], [6736, 3121], [6727, 3057], [6700, 3022], [6710, 2960], [6684, 2940], [6692, 2881], [6674, 2877], [6615, 2929], [6558, 2907], [6539, 2911], [6502, 2885], [6477, 2893], [6428, 2877], [6413, 2865], [6360, 2903], [6387, 2922], [6410, 2972], [6474, 3005], [6469, 3041], [6441, 3067], [6413, 3062], [6382, 3041], [6349, 3045], [6331, 3036], [6328, 3073], [6311, 3076]]]
    }
  }]
}
